(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (() => {
    /* Inline surfboard callout hydration —
       Merchants paste a placeholder div into the article's HTML view:
         <div data-surfboard-callout="handle-a,handle-b,handle-c"
              data-heading="Playa Colorados Surfboards"></div>
       We fetch each product's storefront JSON and swap in a 3-up card
       grid. Runs once per placeholder, guarded so a re-init (theme
       editor section:load) doesn't refetch. */
    const fetched = new Map();
    async function fetchProduct(handle) {
      if (fetched.has(handle)) return fetched.get(handle);
      const p = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }
      }).then((r) => (r.ok ? r.json() : null)).catch(() => null);
      fetched.set(handle, p);
      return p;
    }

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function renderCard(product) {
      if (!product) return '';
      const url = product.url || ('/products/' + product.handle);
      const image = (product.featured_image || (product.images && product.images[0]) || '');
      const brand = product.vendor || '';
      const title = product.title || '';
      const alt = brand ? (brand + ' ' + title) : title;
      return `
        <a class="article-callout__card" href="${escapeHtml(url)}" aria-label="${escapeHtml(alt)}">
          <div class="article-callout__media">
            ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(alt)}" loading="lazy" decoding="async">` : ''}
          </div>
          ${brand ? `<p class="article-callout__brand">${escapeHtml(brand)}</p>` : ''}
          <p class="article-callout__title">${escapeHtml(title)}</p>
        </a>
      `;
    }

    async function hydrate(placeholder) {
      if (placeholder.dataset.callInit === 'true') return;
      placeholder.dataset.callInit = 'true';

      const raw = placeholder.getAttribute('data-surfboard-callout') || '';
      const heading = placeholder.getAttribute('data-heading') || '';
      const handles = raw.split(',').map((s) => s.trim()).filter(Boolean);
      if (!handles.length) return;

      // Convert the placeholder itself into the callout grid.
      placeholder.classList.add('article-callout');
      placeholder.innerHTML = (heading ? `<p class="article-callout__heading">${escapeHtml(heading)}</p>` : '')
        + '<p class="article-callout__loading">Loading surfboards…</p>';

      try {
        const products = await Promise.all(handles.map(fetchProduct));
        const cards = products.filter(Boolean).map(renderCard).join('');
        if (!cards) {
          placeholder.innerHTML = (heading ? `<p class="article-callout__heading">${escapeHtml(heading)}</p>` : '')
            + '<p class="article-callout__error">Couldn\'t load those surfboards.</p>';
          return;
        }
        placeholder.innerHTML = (heading ? `<p class="article-callout__heading">${escapeHtml(heading)}</p>` : '') + cards;
      } catch (err) {
        console.error('Surfboard callout failed', err);
        placeholder.innerHTML = (heading ? `<p class="article-callout__heading">${escapeHtml(heading)}</p>` : '')
          + '<p class="article-callout__error">Couldn\'t load those surfboards.</p>';
      }
    }

    function boot(root) {
      (root || document).querySelectorAll('[data-surfboard-callout]').forEach(hydrate);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot());
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-teaser"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const decodeEntities = (str) => {
      const t = document.createElement('textarea');
      t.innerHTML = str || '';
      return t.value;
    };
    const stripTags = (html) => {
      const d = document.createElement('div');
      d.innerHTML = html || '';
      return d.textContent || '';
    };
    const readingTime = (html) => {
      const words = stripTags(html).trim().split(/\s+/).filter(Boolean).length;
      return Math.max(1, Math.ceil(words / 200));
    };
    const fmtDate = (iso) => {
      const d = new Date(iso);
      if (isNaN(d)) return '';
      return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
    };

    const featuredImage = (post) => {
      const m = post._embedded && post._embedded['wp:featuredmedia'] && post._embedded['wp:featuredmedia'][0];
      if (!m) return '';
      const sizes = m.media_details && m.media_details.sizes;
      const pick = sizes && (sizes.large || sizes.medium_large || sizes.medium);
      return (pick && pick.source_url) || m.source_url || '';
    };

    const categoryName = (post) => {
      const groups = post._embedded && post._embedded['wp:term'];
      if (!groups) return '';
      for (const group of groups) {
        for (const term of group) {
          if (term.taxonomy === 'category' && term.name && term.name.toLowerCase() !== 'uncategorized') {
            return term.name;
          }
        }
      }
      return '';
    };

    const buildCard = (post, newTab) => {
      const title = decodeEntities(post.title && post.title.rendered);
      const li = document.createElement('li');
      li.className = 'blog-teaser__item';

      const a = document.createElement('a');
      a.className = 'blog-card';
      a.href = post.link;
      if (newTab) { a.target = '_blank'; a.rel = 'noopener noreferrer'; }

      const media = document.createElement('div');
      media.className = 'blog-card__media';
      const imgUrl = featuredImage(post);
      if (imgUrl) {
        const img = document.createElement('img');
        img.className = 'blog-card__image';
        img.src = imgUrl;
        img.alt = title;
        img.loading = 'lazy';
        img.decoding = 'async';
        // WordPress uploads are often hotlink-protected; sending no referrer
        // (rather than the cross-origin Shopify origin) lets them load.
        img.referrerPolicy = 'no-referrer';
        img.addEventListener('error', () => { media.classList.add('blog-card__media--empty'); img.remove(); });
        media.appendChild(img);
      }
      a.appendChild(media);

      const meta = document.createElement('div');
      meta.className = 'blog-card__meta';

      const cat = categoryName(post);
      if (cat) {
        const c = document.createElement('p');
        c.className = 'blog-card__cat';
        c.textContent = cat;
        meta.appendChild(c);
      }

      const h3 = document.createElement('h3');
      h3.className = 'blog-card__title';
      const roll = document.createElement('span');
      roll.className = 'blog-card__title-roll';
      const sa = document.createElement('span');
      sa.className = 'blog-card__title-a';
      sa.textContent = title;
      const sb = document.createElement('span');
      sb.className = 'blog-card__title-b';
      sb.setAttribute('aria-hidden', 'true');
      sb.textContent = title;
      roll.append(sa, sb);
      h3.appendChild(roll);
      meta.appendChild(h3);

      const date = document.createElement('p');
      date.className = 'blog-card__date';
      const time = document.createElement('time');
      time.dateTime = post.date;
      time.textContent = fmtDate(post.date);
      date.appendChild(time);
      const rt = readingTime(post.content && post.content.rendered);
      date.appendChild(document.createTextNode(' · ' + rt + ' min read'));
      meta.appendChild(date);

      a.appendChild(meta);
      li.appendChild(a);
      return li;
    };

    const renderFallback = (section, grid) => {
      const mode = section.dataset.onError || 'button';

      // Hide the loading skeletons either way.
      if (grid) grid.style.display = 'none';

      const errorEl = section.querySelector('[data-blog-error]');

      if (mode === 'button' && errorEl && errorEl.children.length) {
        errorEl.hidden = false;
        return;
      }

      // "hide" mode, or button mode with no link configured: remove the section.
      section.style.display = 'none';
    };

    async function loadBlog(section) {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      if (section.dataset.mode !== 'wordpress') return;

      const grid = section.querySelector('[data-blog-grid]');
      const url = section.dataset.apiUrl;
      const count = parseInt(section.dataset.count, 10) || 3;
      const ttl = (parseFloat(section.dataset.cacheHours) || 6) * 3600 * 1000;
      const newTab = section.dataset.newTab === 'true';
      if (!grid || !url) return;

      const cacheKey = 'om:blog:' + url + ':' + count;
      let posts = null;

      try {
        const cached = JSON.parse(localStorage.getItem(cacheKey) || 'null');
        if (cached && cached.t && Array.isArray(cached.d) && Date.now() - cached.t < ttl) {
          posts = cached.d;
        }
      } catch (e) { /* ignore */ }

      if (!posts) {
        try {
          const sep = url.indexOf('?') > -1 ? '&' : '?';
          const res = await fetch(url + sep + '_embed&per_page=' + count);
          if (!res.ok) throw new Error('http ' + res.status);
          posts = await res.json();
          try { localStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), d: posts })); } catch (e) { /* quota */ }
        } catch (e) {
          renderFallback(section, grid);
          return;
        }
      }

      if (!Array.isArray(posts) || !posts.length) {
        renderFallback(section, grid);
        return;
      }

      grid.innerHTML = '';
      posts.slice(0, count).forEach((p) => grid.appendChild(buildCard(p, newTab)));
    }

    const boot = () => document.querySelectorAll('[data-blog-teaser]').forEach(loadBlog);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-blog-teaser]').forEach(loadBlog);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    const body = drawer.querySelector('[data-cart-drawer-body]');
    const foot = drawer.querySelector('[data-cart-drawer-foot]');
    const titleEl = drawer.querySelector('[data-cart-drawer-title]');
    const totalEl = drawer.querySelector('[data-cart-drawer-total]');
    const checkoutTotalEl = drawer.querySelector('[data-cart-drawer-checkout-total]');
    const shippingEl = drawer.querySelector('[data-cart-drawer-shipping]');
    const checkoutBtn = drawer.querySelector('[data-cart-drawer-checkout]');

    const freeCents = parseInt(drawer.dataset.freeShippingCents, 10) || 0;
    // Build the mustache token from char codes so no consecutive raw
    // curly braces appear in this JS source — theme-check otherwise
    // reports the placeholder as a stray Liquid variable in this block.
    const OPEN_MUSTACHE = String.fromCharCode(123, 123);
    const CLOSE_MUSTACHE = String.fromCharCode(125, 125);
    const MUSTACHE = OPEN_MUSTACHE + 'amount' + CLOSE_MUSTACHE;
    const moneyFormat = drawer.dataset.moneyFormat || ('£' + MUSTACHE);
    const emptyShopUrl = drawer.dataset.emptyShopUrl || '/collections/all';
    const emptyShopLabel = drawer.dataset.emptyShopLabel || 'Shop boards';
    const checkoutUrl = drawer.dataset.checkoutUrl || '/checkout';
    const basketUrl = drawer.dataset.basketUrl || '/cart';

    /* --- Money formatting ---
       Shopify's money_format uses double-curly placeholders (amount /
       amount_no_decimals). We build the regex from escaped braces so no
       consecutive raw braces appear in this JS source — keeps the theme
       linter happy while still matching every placeholder variant. */
    const moneyPlaceholder = new RegExp('\\{\\{\\s*amount(_no_decimals)?\\s*\\}\\}', 'g');
    function formatMoney(cents) {
      const value = (cents / 100).toFixed(2);
      return moneyFormat.replace(moneyPlaceholder, value);
    }

    function escapeHtml(str) {
      if (str == null) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    /* --- Body scroll lock --- */
    let lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      refresh();
      // Focus close button for keyboard users.
      const closeBtn = drawer.querySelector('.cart-drawer__close');
      if (closeBtn) requestAnimationFrame(() => closeBtn.focus());
    }

    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    /* --- Render helpers --- */
    function renderEmpty() {
      body.innerHTML = `
        <div class="cart-drawer__empty">
          <p>Your basket is empty.</p>
          <a class="cart-drawer__empty-link" href="${escapeHtml(emptyShopUrl)}" data-cart-drawer-close>
            ${escapeHtml(emptyShopLabel)} &rarr;
          </a>
        </div>
      `;
      foot.hidden = true;
    }

    function renderLine(item) {
      const onSale = item.original_line_price > item.line_price;
      const wasPrice = onSale
        ? `<span class="cart-drawer__item-price-was">${formatMoney(item.original_line_price)}</span>`
        : '';
      const brand = item.product_type == "Shape3d" ? '' : item.vendor || item.product_vendor || '';
      const imgSrc = item.product_type == "Shape3d"
        ? "https://www.shape3d.com/BoardDesigner/Boards/" + item.properties["_Client"] + "/Orders/" + item.properties["_Order"] + "_Small.png" : item.image
        ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?.*)?$/, '_200x$1')
        : '';
      const alt = escapeHtml(`${brand} ${item.product_title || item.title || ''}`.trim());
      if (item.product_type == "Shape3d") {
        item.url = "/pages/board-builder?Order=" + item.properties["_Order"];
      }
      return `
        <li>
          <div class="cart-drawer__item" data-cart-line-key="${escapeHtml(item.key)}">
            <a class="cart-drawer__item-media" href="${escapeHtml(item.url)}" data-cart-drawer-close>
              ${imgSrc ? `<img src="${escapeHtml(imgSrc)}" alt="${alt}" loading="lazy">` : ''}
            </a>
            <div class="cart-drawer__item-body">
              <div class="cart-drawer__item-topline">
                <div class="cart-drawer__item-titleblock">
                  ${brand ? `<p class="cart-drawer__item-brand">${escapeHtml(brand)}</p>` : ''}
                  <a class="cart-drawer__item-name" href="${escapeHtml(item.url)}" title="${escapeHtml(item.product_title || item.title)}" data-cart-drawer-close>
                    ${escapeHtml(item.product_title || item.title)}
                  </a>
                </div>
                <button type="button" class="cart-drawer__item-remove" data-cart-remove aria-label="Remove ${escapeHtml(item.product_title || item.title)}">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="m6 6 12 12M18 6 6 18" />
                  </svg>
                </button>
              </div>
              <div class="cart-drawer__item-baseline">
                <div class="cart-drawer__qty">
                  <button type="button" class="cart-drawer__qty-btn" data-cart-qty="-1" aria-label="Decrease quantity">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <path d="M5 12h14" />
                    </svg>
                  </button>
                  <span class="cart-drawer__qty-value">${item.quantity}</span>
                  <button type="button" class="cart-drawer__qty-btn" data-cart-qty="1" aria-label="Increase quantity">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <path d="M12 5v14M5 12h14" />
                    </svg>
                  </button>
                </div>
                <div class="cart-drawer__item-prices">
                  ${wasPrice}
                  <span class="cart-drawer__item-price">${formatMoney(item.line_price)}</span>
                </div>
              </div>
            </div>
          </div>
        </li>
      `;
    }

    function render(cart) {
      // Header count
      titleEl.textContent = cart.item_count > 0 ? `Basket · ${cart.item_count}` : 'Basket';

      // Sync all header cart count badges — some may be off-screen but the
      // markup always keeps them in the DOM.
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        if (cart.item_count === 0) {
          el.setAttribute('hidden', '');
        } else {
          el.removeAttribute('hidden');
        }
      });

      if (!cart.items || cart.items.length === 0) {
        renderEmpty();
        return;
      }

      body.innerHTML = `<ul class="cart-drawer__list">${cart.items.map(renderLine).join('')}</ul>`;
      foot.hidden = false;

      totalEl.textContent = formatMoney(cart.total_price);
      checkoutTotalEl.textContent = formatMoney(cart.total_price);

      const remaining = Math.max(0, freeCents - cart.total_price);
      shippingEl.textContent = remaining === 0
        ? 'Fast UK shipping included.'
        : `${formatMoney(remaining)} from fast UK shipping.`;

      checkoutBtn.setAttribute('href', checkoutUrl);
    }

    /* --- Data layer --- */
    let inflight = 0;
    let loadingCount = 0;
    async function fetchCart() {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      return res.json();
    }

    async function refresh() {
      const my = ++inflight;
      try {
        const cart = await fetchCart();
        if (my !== inflight) return; // stale
        render(cart);
      } catch (e) {
        console.error('Cart refresh failed', e);
      }
    }

    const noticeEl = drawer.querySelector('[data-cart-drawer-notice]');
    const noticeTextEl = drawer.querySelector('[data-cart-drawer-notice-text]');

    function showNotice(message) {
      if (!noticeEl || !noticeTextEl) return;
      noticeTextEl.textContent = message;
      noticeEl.hidden = false;
    }
    function clearNotice() {
      if (!noticeEl) return;
      noticeEl.hidden = true;
      if (noticeTextEl) noticeTextEl.textContent = '';
    }

    function setLoading(on) {
      // Multiple in-flight mutations shouldn't clear the overlay early —
      // we only hide it once every open request has resolved.
      if (on) {
        loadingCount += 1;
        drawer.setAttribute('data-loading', 'true');
      } else {
        loadingCount = Math.max(0, loadingCount - 1);
        if (loadingCount === 0) drawer.removeAttribute('data-loading');
      }
    }

    async function changeLine(key, quantity) {
      const my = ++inflight;
      setLoading(true);
      clearNotice();
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ id: key, quantity })
        });
        const body = await res.json();
        if (my !== inflight) return;

        // Shopify returns errors as either a non-2xx status with
        // `{status, message, description}`, or (occasionally) a 2xx
        // response containing a `status` field with the numeric HTTP
        // code. Anything that isn't a full cart object (has `items`)
        // is treated as an error — the drawer needs the real cart to
        // stay in sync, so refresh from /cart.js.
        if (!res.ok || !body || !Array.isArray(body.items)) {
          const msg = (body && (body.description || body.message))
            || 'Something went wrong updating your basket.';
          showNotice(msg);
          const cart = await fetchCart();
          if (my !== inflight) return;
          render(cart);
          return;
        }

        render(body);
      } catch (e) {
        console.error('Cart change failed', e);
        showNotice('Network error — please try again.');
      } finally {
        setLoading(false);
      }
    }

    /* --- Event delegation ---
       All buttons inside the drawer are matched here so re-renders don't
       have to re-bind handlers. Also handles any bag-icon / add-to-bag
       trigger in the wider page via `[data-cart-open]`. */
    drawer.addEventListener('click', (evt) => {
      const dismiss = evt.target.closest('[data-cart-drawer-notice-dismiss]');
      if (dismiss) {
        evt.preventDefault();
        clearNotice();
        return;
      }

      const closer = evt.target.closest('[data-cart-drawer-close]');
      if (closer) {
        // View-basket link should still navigate — only intercept the pure
        // scrim/close buttons. `.cart-drawer__view` navigates but we let
        // the drawer close naturally by not preventing default.
        if (closer.tagName === 'A') {
          close();
          return;
        }
        evt.preventDefault();
        close();
        return;
      }

      const itemEl = evt.target.closest('[data-cart-line-key]');
      if (!itemEl) return;
      const key = itemEl.dataset.cartLineKey;
      const currentQty = parseInt(itemEl.querySelector('.cart-drawer__qty-value')?.textContent || '0', 10);

      const qtyBtn = evt.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        evt.preventDefault();
        const delta = parseInt(qtyBtn.dataset.cartQty, 10);
        const next = Math.max(0, currentQty + delta);
        changeLine(key, next);
        return;
      }

      const remBtn = evt.target.closest('[data-cart-remove]');
      if (remBtn) {
        evt.preventDefault();
        changeLine(key, 0);
        return;
      }
    });

    // Keyboard: Escape closes.
    document.addEventListener('keydown', (evt) => {
      if (evt.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        close();
      }
    });

    // Global bag-icon / trigger delegation.
    document.addEventListener('click', (evt) => {
      const opener = evt.target.closest('[data-cart-open]');
      if (opener) {
        evt.preventDefault();
        open();
      }
    });

    // Fetch interceptor —
    // Any successful POST to /cart/add.js (quick-view, fins upsell,
    // catalogue card, PDP fallback, etc.) automatically opens the drawer.
    // Keeps section-level handlers free of drawer-specific wiring.
    const nativeFetch = window.fetch.bind(window);
    window.fetch = async function (input, init) {
      const res = await nativeFetch(input, init);
      try {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        const method = ((init && init.method) || (input && input.method) || 'GET').toString().toUpperCase();
        const isAddCall = method === 'POST'
          && (url.indexOf('/cart/add.js') !== -1 || (url.indexOf('/cart/add') !== -1 && url.endsWith('.js')));
        if (isAddCall) {
          if (res.ok) {
            setTimeout(() => open(), 0);
          } else {
            // Non-2xx add response — Shopify sends `{status, message, description}`.
            // Clone so we don't consume the response body from the caller.
            res.clone().json().then((body) => {
              const msg = (body && (body.description || body.message))
                || 'Could not add to basket.';
              showNotice(msg);
              setTimeout(() => open(), 0);
            }).catch(() => {
              showNotice('Could not add to basket.');
              setTimeout(() => open(), 0);
            });
          }
        }
      } catch (_) { /* never let interception break the caller */ }
      return res;
    };

    // Expose a tiny public API so PDPs / add-to-bag flows can drive us.
    window.oceanCart = {
      open,
      close,
      refresh
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-basket]');
    if (!section) return;

    const sectionId = section.dataset.sectionId;
    let inner = section.querySelector('[data-basket-inner]');
    let inflight = 0;
    let loadingCount = 0;

    const noticeEl = section.querySelector('[data-basket-notice]');
    const noticeTextEl = section.querySelector('[data-basket-notice-text]');

    /* Position the notice inside .basket__items right after the
       progress/unlocked block. Falls back to a section-level position
       if the items column isn't rendered (e.g. empty state). */
    function positionNotice() {
      if (!noticeEl || noticeEl.hidden) return;
      const items = inner && inner.querySelector('.basket__items');
      if (!items) {
        if (noticeEl.parentElement !== section) section.appendChild(noticeEl);
        return;
      }
      const anchor = items.querySelector('.basket__progress, .basket__unlocked');
      if (anchor) {
        anchor.insertAdjacentElement('afterend', noticeEl);
      } else {
        items.insertBefore(noticeEl, items.firstChild);
      }
    }

    /* Detach the notice back into the section root so a swap()
       replacing [data-basket-inner] doesn't destroy it. */
    function detachNotice() {
      if (noticeEl && noticeEl.parentElement !== section) {
        section.appendChild(noticeEl);
      }
    }

    function showNotice(msg) {
      if (!noticeEl || !noticeTextEl) return;
      noticeTextEl.textContent = msg;
      noticeEl.hidden = false;
      positionNotice();
    }
    function clearNotice() {
      if (!noticeEl) return;
      noticeEl.hidden = true;
      if (noticeTextEl) noticeTextEl.textContent = '';
    }

    function setLoading(on) {
      if (on) {
        loadingCount += 1;
        section.setAttribute('data-loading', 'true');
      } else {
        loadingCount = Math.max(0, loadingCount - 1);
        if (loadingCount === 0) section.removeAttribute('data-loading');
      }
    }

    /* --- Re-render the whole cart section from Section Rendering API,
       swap the inner DOM in place. Preserves scroll position and any
       focus by only touching the inside of [data-basket-inner]. --- */
    async function swap(cart) {
      const html = cart && cart.sections && cart.sections[sectionId]
        ? cart.sections[sectionId]
        : null;
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextInner = doc.querySelector('[data-basket-inner]');
      if (!nextInner) return;
      // Rescue the notice out of the old inner before it's replaced, so
      // the DOM swap doesn't destroy it. Re-position after the swap so
      // it lands under the freshly-rendered progress panel.
      detachNotice();
      inner.replaceWith(nextInner);
      inner = nextInner;
      positionNotice();
      // Also sync the header cart-count badge.
      if (typeof cart.item_count === 'number') {
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          if (cart.item_count === 0) el.setAttribute('hidden', '');
          else el.removeAttribute('hidden');
        });
      }
    }

    async function fetchCartWithSection() {
      // /cart.js gives fresh totals/item_count; /cart?sections=<id> gives
      // the freshly-rendered section HTML. Together they mirror the shape
      // /cart/change.js normally returns, so swap() can consume the result
      // in exactly the same way.
      const [sectionsRes, cartRes] = await Promise.all([
        fetch('/cart?sections=' + encodeURIComponent(sectionId), { headers: { Accept: 'application/json' } }),
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
      ]);
      const sections = await sectionsRes.json();
      const cart = await cartRes.json();
      cart.sections = sections;
      return cart;
    }

    async function changeLine(key, quantity) {
      const my = ++inflight;
      setLoading(true);
      clearNotice();
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections: sectionId })
        });
        const body = await res.json();
        if (my !== inflight) return;

        // Shopify returns errors as `{status, message, description}`
        // (with a non-2xx status, or occasionally a 2xx body carrying
        // the numeric status). Anything without a rendered `sections`
        // payload is treated as a failure — the real cart still needs
        // to be re-synced so we fetch it separately.
        if (!res.ok || !body || !body.sections) {
          const msg = (body && (body.description || body.message))
            || 'Something went wrong updating your basket.';
          showNotice(msg);
          const cart = await fetchCartWithSection();
          if (my !== inflight) return;
          await swap(cart);
          return;
        }

        await swap(body);
      } catch (err) {
        console.error('Cart change failed', err);
        showNotice('Network error — please try again.');
      } finally {
        setLoading(false);
      }
    }

    async function updateNote(note) {
      const my = ++inflight;
      setLoading(true);
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note, sections: sectionId })
        });
        const body = await res.json();
        if (my !== inflight) return;

        if (!res.ok || !body || !Array.isArray(body.items)) {
          const msg = (body && (body.description || body.message))
            || 'Could not save your note.';
          showNotice(msg);
          return;
        }

        // Note updates don't need a re-render — the textarea already
        // shows the new text and totals are unchanged. Only touch the
        // header cart-count sync path.
        if (typeof body.item_count === 'number') {
          document.querySelectorAll('[data-cart-count]').forEach((el) => {
            el.textContent = body.item_count;
          });
        }
      } catch (err) {
        console.error('Note update failed', err);
        showNotice('Network error — could not save your note.');
      } finally {
        setLoading(false);
      }
    }

    /* --- Event delegation on the section — survives full inner swaps --- */
    section.addEventListener('click', (evt) => {
      const dismiss = evt.target.closest('[data-basket-notice-dismiss]');
      if (dismiss) {
        evt.preventDefault();
        clearNotice();
        return;
      }

      const row = evt.target.closest('[data-basket-line-key]');
      const noteOpen = evt.target.closest('[data-basket-note-open]');
      const promoOpen = evt.target.closest('[data-basket-promo-open]');

      if (noteOpen) {
        evt.preventDefault();
        const form = noteOpen.closest('[data-basket-note-form]');
        noteOpen.classList.add('is-hidden');
        const body = form.querySelector('[data-basket-note-body]');
        body.classList.remove('is-hidden');
        body.querySelector('textarea')?.focus();
        return;
      }

      if (promoOpen) {
        evt.preventDefault();
        promoOpen.classList.add('is-hidden');
        const body = promoOpen.parentElement.querySelector('[data-basket-promo-body]');
        body.classList.remove('is-hidden');
        body.querySelector('input')?.focus();
        return;
      }

      if (!row) return;
      const key = row.dataset.basketLineKey;
      const currentQty = parseInt(row.querySelector('[data-basket-qty-value]')?.textContent || '0', 10);

      const qtyBtn = evt.target.closest('[data-basket-qty-delta]');
      if (qtyBtn) {
        evt.preventDefault();
        const delta = parseInt(qtyBtn.dataset.basketQtyDelta, 10);
        const next = Math.max(0, currentQty + delta);
        changeLine(key, next);
        return;
      }

      const removeBtn = evt.target.closest('[data-basket-remove]');
      if (removeBtn) {
        evt.preventDefault();
        changeLine(key, 0);
        return;
      }
    });

    /* --- Order note: save on blur (in addition to non-JS form submit) --- */
    section.addEventListener('blur', (evt) => {
      const ta = evt.target.closest('[data-basket-note-input]');
      if (!ta) return;
      updateNote(ta.value);
    }, true);

    /* --- Promo code Apply → activate via /discount/CODE which redirects
       back to /cart. Shopify surfaces invalid codes as a flash on the
       cart page. --- */
    section.addEventListener('submit', (evt) => {
      const form = evt.target.closest('[data-basket-promo-body]');
      if (!form) return;
      evt.preventDefault();
      const input = form.querySelector('[data-basket-promo-input]');
      const code = (input?.value || '').trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    /* --- Helpers used everywhere --- */
    function formatMoney(cents, format) {
      const amount = cents / 100;
      const withDecimals = amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const noDecimals = Math.round(amount).toLocaleString();
      if (!format) return withDecimals;
      const brace = String.fromCharCode(123);
      const re = new RegExp(brace + brace + '\\s*(amount_no_decimals|amount_with_comma_separator|amount_with_space_separator|amount)\\s*\\}\\}', 'g');
      return format.replace(re, (m, token) => (token === 'amount_no_decimals' ? noDecimals : withDecimals));
    }

    async function refreshCartCount() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
        });
      } catch (e) { /* ignore */ }
    }

    /* --- Favourites --- */
    const FAV_KEY = 'om:favourites';
    const getFavourites = () => { try { return JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); } catch (e) { return []; } };
    const setFavourites = (list) => localStorage.setItem(FAV_KEY, JSON.stringify(list));

    function initFavourites(root) {
      const favs = getFavourites();
      root.querySelectorAll('[data-favourite]').forEach((btn) => {
        const id = btn.getAttribute('data-favourite');
        if (favs.includes(id)) btn.setAttribute('aria-pressed', 'true');
        btn.addEventListener('click', () => {
          const current = getFavourites();
          const pressed = btn.getAttribute('aria-pressed') === 'true';
          if (pressed) {
            btn.setAttribute('aria-pressed', 'false');
            setFavourites(current.filter((x) => x !== id));
          } else {
            btn.setAttribute('aria-pressed', 'true');
            if (!current.includes(id)) current.push(id);
            setFavourites(current);
          }
        });
      });
    }

    function markSecondary(root) {
      root.querySelectorAll('[data-product-card]').forEach((card) => {
        if (card.querySelector('.card__image--secondary')) {
          card.querySelector('.card__image--primary')?.classList.add('has-secondary');
        }
      });
    }

    function initAddToCart(root) {
      root.querySelectorAll('[data-card-add]').forEach((form) => {
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = form.querySelector('button[type="submit"]');
          const labels = form.querySelectorAll('.card__roll-a, .card__roll-b');
          const original = labels[0] ? labels[0].textContent.trim() : 'Add to bag';
          if (button) button.disabled = true;
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 })
            });
            if (!res.ok) throw new Error('add failed');
            await refreshCartCount();
            labels.forEach((l) => { l.textContent = 'Added ✓'; });
            setTimeout(() => {
              labels.forEach((l) => { l.textContent = original; });
              if (button) button.disabled = false;
            }, 1600);
          } catch (e) { form.submit(); }
        });
      });
    }

    /* --- Mobile drawer ---
       Uses delegation on the section so open / close triggers keep
       working after every AJAX filter swap (the toolbar open button and
       the drawer-foot "Show N" button both live in swap zones). The
       drawer wrapper itself is never swapped, so its aria-hidden state
       persists across filter updates. */
    function initDrawer(section) {
      const drawer = section.querySelector('[data-catalogue-drawer]');
      if (!drawer) return;

      const openBtn = () => section.querySelector('[data-catalogue-open-drawer]');
      let lastTrigger = null;

      const open = (triggerEl) => {
        lastTrigger = triggerEl || openBtn();
        drawer.setAttribute('aria-hidden', 'false');
        openBtn()?.setAttribute('aria-expanded', 'true');
        document.body.classList.add('catalogue-drawer-open');
        // Move focus into the drawer so keyboard users can operate it.
        // Timeout so the CSS transition-in has a paint tick first.
        setTimeout(() => {
          drawer.querySelector('.catalogue__drawer-close')?.focus();
        }, 60);
      };

      const close = () => {
        drawer.setAttribute('aria-hidden', 'true');
        openBtn()?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('catalogue-drawer-open');
        // Return focus to whatever opened the drawer.
        lastTrigger?.focus?.();
        lastTrigger = null;
      };

      section.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-catalogue-open-drawer]');
        if (opener && section.contains(opener)) {
          event.preventDefault();
          open(opener);
          return;
        }
        const closer = event.target.closest('[data-catalogue-close-drawer]');
        if (closer && drawer.contains(closer)) {
          event.preventDefault();
          close();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
      });
    }

    /* --- Filter group collapse/expand --- */
    function initFilterGroups(section) {
      section.querySelectorAll('[data-catalogue-group]').forEach((group) => {
        const btn = group.querySelector('[data-catalogue-group-toggle]');
        btn?.addEventListener('click', () => {
          const open = group.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    }

    /* --- Section-rendering AJAX: swap markup without a page reload --- */
    function swapNode(root, doc, selector) {
      const olds = root.querySelectorAll(selector);
      const news = doc.querySelectorAll(selector);
      olds.forEach((oldEl, i) => {
        if (news[i]) oldEl.replaceWith(news[i]);
      });
    }

    // Monotonic id used to discard stale swaps when the user rapidly
    // changes filters. Each applyFilters bumps the counter; if a fetch
    // resolves and the counter has moved on, we throw its result away.
    let latestFetchId = 0;

    async function applyFilters(section, urlOrParams, sourceForm) {
      const myId = ++latestFetchId;
      section.classList.add('is-loading');
      // Any filter/sort/page change invalidates a previous "load all
      // pages for sale-only" run — the fresh grid may hold different
      // products and its own pagination. If the sale toggle is still
      // on after the swap, `initFilterForms` re-runs the toggle's
      // `applyState(true)` on the fresh markup, which triggers the
      // loader against the new result set. Clear the in-flight guard
      // too so a superseded load doesn't block the fresh one.
      delete section.dataset.saleAllLoaded;
      delete section.dataset.saleLoadInFlight;

      const sectionId = section.getAttribute('data-section-id');
      const collectionUrl = section.getAttribute('data-collection-url');
      let fetchUrl;

      try {
        if (typeof urlOrParams === 'string') {
          fetchUrl = new URL(urlOrParams, window.location.origin);
        } else {
          fetchUrl = new URL(collectionUrl, window.location.origin);
          Object.entries(urlOrParams || {}).forEach(([key, val]) => {
            if (val == null) return;
            // Empty-string values used to be skipped, but Shopify's
            // boolean filters (e.g. "On sale only") sometimes emit a
            // checkbox with an empty `value=""`. Skipping empty values
            // meant the toggle's URL param never reached the server,
            // the filter didn't apply, and the fresh sidebar came back
            // with the toggle un-ticked. Include filter.* params
            // regardless of value; only skip empty non-filter params
            // (like an unused sort_by) to keep URLs clean.
            const isFilter = typeof key === 'string' && key.indexOf('filter.') === 0;
            if (!isFilter && val === '') return;
            if (Array.isArray(val)) val.forEach((v) => fetchUrl.searchParams.append(key, v));
            else fetchUrl.searchParams.set(key, val);
          });
        }
        // Strip any stale section_id, then set the current one.
        fetchUrl.searchParams.delete('section_id');
        fetchUrl.searchParams.set('section_id', sectionId);

        // Capture the outgoing URL's params so we can reapply them
        // to any range-slider inputs after the swap. Shopify's Section
        // Rendering API doesn't reliably populate `filter.max_value.value`
        // from URL params — the fresh sidebar's Liquid can fall back to
        // the ceiling even when a `filter.v.price.lte=...` param was
        // sent, which would visually reset the slider to max the instant
        // the swap lands (even though the products themselves filter
        // correctly). Restoring the value client-side sidesteps that.
        const outgoingParams = {};
        fetchUrl.searchParams.forEach((val, key) => {
          if (key !== 'section_id' && val !== '') outgoingParams[key] = val;
        });

        const res = await fetch(fetchUrl.toString(), { headers: { Accept: 'text/html' } });
        if (myId !== latestFetchId) return; // superseded, discard
        if (!res.ok) throw new Error(`section fetch ${res.status}`);
        const html = await res.text();
        if (myId !== latestFetchId) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Capture internal scroll positions BEFORE the swap. Both the
        // sticky desktop sidebar (.catalogue__sidebar) and the mobile
        // drawer body (.catalogue__drawer-body) sit inside a swap zone,
        // so their new copies would otherwise reset to scrollTop 0 and
        // yank the user's view back to the top of the filter list.
        const preservedScroll = {};
        ['.catalogue__sidebar', '.catalogue__drawer-body'].forEach((sel) => {
          const el = section.querySelector(sel);
          if (el) preservedScroll[sel] = el.scrollTop;
        });

        // Capture dual-thumb slider positions BEFORE the swap. The
        // fresh Liquid recomputes bounds/current values from the
        // metafield's discrete values (5.0, 6.0, 7.0 = feet), so the
        // slider would visually snap to the nearest metafield value
        // on release even if the shopper had dragged between them.
        // We restore the user's actual drag positions after the swap
        // so the handles + pill labels stay where they let go.
        //
        // Keyed off the first hidden checkbox's `name` attribute
        // (always the filter's Shopify param, e.g. `filter.p.m.length`)
        // rather than any range-level attribute — this stays robust
        // if the range wrapper attribute is missing or unversioned on
        // the current page's initial render.
        const readMultiKey = (range) => {
          const cb = range.querySelector('input[type="checkbox"][name]');
          return cb ? cb.getAttribute('name') : null;
        };
        // The section renders each dual-thumb slider TWICE — once in
        // the desktop sidebar, once in the mobile drawer. Only the
        // ranges in the form the shopper actually interacted with
        // hold their newly-dragged values; the other form's copy
        // still holds the previous cycle's restored values (which are
        // "non-default" but stale). Scope capture to the triggering
        // form when available so we don't accidentally overwrite the
        // fresh drag with the stale copy. Fallback to section-wide
        // for callers that don't have a form context (pagination
        // links, sort dropdown clicks).
        const captureScope = sourceForm || section;
        const preservedMultiRanges = {};
        captureScope.querySelectorAll('.catalogue-range--dual').forEach((range) => {
          const key = readMultiKey(range);
          if (!key) return;
          const minEl = range.querySelector('[data-min-input]');
          const maxEl = range.querySelector('[data-max-input]');
          if (!minEl || !maxEl) return;
          preservedMultiRanges[key] = { min: minEl.value, max: maxEl.value };
        });

        // Capture every filter checkbox's checked state from the
        // triggering form so we can put the shopper's intent back on
        // the fresh sidebar. Fixes the "On sale only" boolean toggle
        // (and any other filter) that flips off after AJAX because
        // Shopify's server-side `filter.true_value.active` doesn't
        // always reflect the URL param it received. Skips the hidden
        // checkboxes inside dual-range sliders (those get resynced
        // from slider positions by paramsFromForm).
        // Keyed by name + "::" + value so list filters with multiple
        // values (e.g. brand=pyzel + brand=lost) preserve each entry
        // individually.
        const preservedCheckboxes = {};
        if (sourceForm) {
          sourceForm
            .querySelectorAll('input[type=checkbox]:not([data-catalogue-multi-value])')
            .forEach((cb) => {
              const name = cb.getAttribute('name');
              if (!name) return;
              preservedCheckboxes[name + '::' + cb.value] = cb.checked;
            });
        }

        // Swap the parts that change with filters/sort/page. The section
        // wrapper itself stays put so global listeners (delegation for
        // Quick view, mobile drawer toggles) persist across swaps.
        swapNode(section, doc, '.catalogue__body');
        swapNode(section, doc, '.catalogue__drawer-body');
        swapNode(section, doc, '.catalogue__drawer-foot');

        // Restore captured scroll positions on the fresh markup. Done in
        // an rAF so the browser has laid out the new elements first.
        requestAnimationFrame(() => {
          Object.entries(preservedScroll).forEach(([sel, top]) => {
            const el = section.querySelector(sel);
            if (el) el.scrollTop = top;
          });
        });

        // Reapply outgoing URL params onto any matching single-thumb
        // range slider inputs BEFORE initFilterForms runs — its per-
        // slider `paint()` then uses the correct value on init, so the
        // slider handle and the "Up to £X" pill both reflect the
        // applied filter instead of Liquid's fallback ceiling. Iterate
        // every range input, compare its `name` attribute directly to
        // the outgoing params — avoids any CSS-selector escaping
        // quirks with the dot-heavy Shopify filter param names.
        const singleThumbInputs = section.querySelectorAll(
          '.catalogue-range__input:not([data-min-input]):not([data-max-input])'
        );
        singleThumbInputs.forEach((input) => {
          const name = input.getAttribute('name');
          if (name && outgoingParams[name] != null) {
            input.value = outgoingParams[name];
          }
        });

        // Restore dual-thumb slider positions on the freshly-swapped
        // sidebar (and mobile drawer) so the handles stay exactly
        // where the shopper released them instead of snapping to the
        // nearest metafield value the Liquid recomputed. Applied to
        // both min and max inputs of every matching range, and the
        // clamp is delegated to the browser (the range input clamps
        // out-of-range values to its own min/max automatically).
        // Matches by the hidden checkbox's `name` attribute (the
        // filter's Shopify param) via `readMultiKey` — same lookup
        // used during capture so it works whether or not the range
        // wrapper carries a versioned `data-catalogue-multi-range`
        // value.
        section.querySelectorAll('.catalogue-range--dual').forEach((range) => {
          const key = readMultiKey(range);
          if (!key || !preservedMultiRanges[key]) return;
          const positions = preservedMultiRanges[key];
          const minEl = range.querySelector('[data-min-input]');
          const maxEl = range.querySelector('[data-max-input]');
          if (minEl) minEl.value = positions.min;
          if (maxEl) maxEl.value = positions.max;
        });

        // Reapply the shopper's checkbox state to the freshly-swapped
        // sidebar (both desktop + mobile copies stay in sync). Ensures
        // any filter the server didn't visibly re-tick — most notably
        // boolean toggles like "On sale only" — still shows the
        // shopper's actual selection. Also mirrors the label's
        // `.is-active` class for the toggle style variants so the
        // switch visual matches its underlying checkbox state.
        if (Object.keys(preservedCheckboxes).length > 0) {
          section
            .querySelectorAll('input[type=checkbox]:not([data-catalogue-multi-value])')
            .forEach((cb) => {
              const name = cb.getAttribute('name');
              if (!name) return;
              const key = name + '::' + cb.value;
              if (Object.prototype.hasOwnProperty.call(preservedCheckboxes, key)) {
                cb.checked = preservedCheckboxes[key];
                const toggle = cb.closest('[data-catalogue-toggle]');
                if (toggle) toggle.classList.toggle('is-active', preservedCheckboxes[key]);
              }
            });
        }

        // Re-bind behaviours on the freshly inserted DOM.
        markSecondary(section);
        initFavourites(section);
        initAddToCart(section);
        initFilterGroups(section);
        initFilterForms(section);
        initSortDropdowns(section);
      } catch (e) {
        if (myId === latestFetchId) console.warn('[catalogue] filter update failed:', e);
      } finally {
        if (myId === latestFetchId) section.classList.remove('is-loading');
      }
    }

    /* Length-string parser hoisted to file scope so paramsFromForm can
       reuse it for slider→checkbox sync. Handles all three metafield
       shapes ("5'6\"", "5.5", "66") → total inches. */
    function parseLengthToInches(str) {
      if (typeof str !== 'string') return NaN;
      const trimmed = str.trim();
      if (trimmed.indexOf("'") > -1) {
        const parts = trimmed.split("'");
        const ft = parseInt(parts[0], 10) || 0;
        const inStr = (parts[1] || '').replace(/["'\s]/g, '');
        const inches = parseInt(inStr, 10) || 0;
        return ft * 12 + inches;
      }
      const n = parseFloat(trimmed);
      if (isNaN(n)) return NaN;
      return n >= 24 ? n : n * 12;
    }

    /* Sentinel value emitted for a dual-slider filter when the shopper's
       range is narrower than the full metafield spread but no discrete
       metafield values fall inside it. Sending this to Shopify makes it
       filter for a value no product has, so the results page correctly
       shows zero products instead of silently dropping the filter and
       showing everything. */
    const CATALOGUE_EMPTY_SENTINEL = '__catalogue_no_match__';

    /* Build a params object from an intercepted form's current inputs.
       Also syncs each dual-slider's hidden checkboxes to the current
       slider position first, so the form data reflects what the shopper
       currently sees. Injects a sentinel filter value for any active
       range that has no matching checkboxes. */
    function paramsFromForm(form) {
      // Sync dual-slider checkboxes with slider positions. Fresh Liquid
      // may render checkboxes for previously-active values that no
      // longer match the shopper's current slider drag — this brings
      // them back in line before we serialise the form.
      form.querySelectorAll('.catalogue-range--dual').forEach((range) => {
        const hiddenBoxes = range.querySelectorAll('[data-catalogue-multi-value]');
        const minInput = range.querySelector('[data-min-input]');
        const maxInput = range.querySelector('[data-max-input]');
        if (!minInput || !maxInput || !hiddenBoxes.length) return;
        const minBound = Number(range.getAttribute('data-min'));
        const maxBound = Number(range.getAttribute('data-max'));
        const minV = Number(minInput.value);
        const maxV = Number(maxInput.value);
        const isFullRange = minV === minBound && maxV === maxBound;
        const format = range.getAttribute('data-format') || '';
        hiddenBoxes.forEach((cb) => {
          let v;
          if (format === 'length') {
            v = parseLengthToInches(cb.value);
          } else {
            v = Number(cb.getAttribute('data-catalogue-multi-value'));
          }
          cb.checked = !isFullRange && !isNaN(v) && v >= minV && v <= maxV;
        });
      });

      const params = {};
      new FormData(form).forEach((value, key) => {
        if (key === 'section_id') return;
        if (params[key] != null) {
          if (Array.isArray(params[key])) params[key].push(value);
          else params[key] = [params[key], value];
        } else {
          params[key] = value;
        }
      });

      // For each dual-slider that's narrowed but produced no matching
      // checkboxes, inject the sentinel value so Shopify's filter runs
      // (and returns nothing) instead of the length filter being absent
      // from the URL entirely (which would show every product).
      form.querySelectorAll('.catalogue-range--dual').forEach((range) => {
        const anyCheckbox = range.querySelector('input[type="checkbox"][name]');
        if (!anyCheckbox) return;
        const name = anyCheckbox.getAttribute('name');
        if (!name) return;
        const minInput = range.querySelector('[data-min-input]');
        const maxInput = range.querySelector('[data-max-input]');
        if (!minInput || !maxInput) return;
        const minBound = Number(range.getAttribute('data-min'));
        const maxBound = Number(range.getAttribute('data-max'));
        const minV = Number(minInput.value);
        const maxV = Number(maxInput.value);
        const isFullRange = minV === minBound && maxV === maxBound;
        // Only when the range is actively narrowed AND no metafield
        // value survived the sync — full range means "no length filter
        // wanted", and a populated params entry means real matches exist.
        if (!isFullRange && params[name] == null) {
          params[name] = CATALOGUE_EMPTY_SENTINEL;
        }
      });

      return params;
    }

    /* Multi-page loader for the "On sale only" toggle.

       Sale is a Shopify Collection, so we can't filter server-side for
       "products in current collection ∩ sale collection". The toggle
       hides non-sale cards via CSS on `.is-sale-only`. On a paginated
       collection this only filters the CURRENT page — pages 2..N would
       be invisible to the CSS filter. This function fetches every OTHER
       page via Section Rendering (with the same filters/sort applied)
       and appends their `.catalogue__item` nodes to the grid so the
       CSS filter has the full result set to operate on.

       Idempotent per-fetch: `section.dataset.saleAllLoaded === 'true'`
       marks that all pages are already in the DOM. `applyFilters`
       clears the flag whenever the base grid is re-fetched, so a
       subsequent filter change while still in sale-only mode will
       re-run this loader against the fresh result set. */
    let latestSaleLoadId = 0;
    async function loadAllSalePages(section, sourceForm) {
      if (section.dataset.saleAllLoaded === 'true') return;
      // In-flight guard — desktop + mobile toggle bindings both call
      // this after AJAX re-init, and without the guard both would race
      // through the pre-flag check and issue the same fetch twice.
      if (section.dataset.saleLoadInFlight === 'true') return;
      const grid = section.querySelector('[data-catalogue-grid]');
      if (!grid) return;
      const totalPages = Number(grid.getAttribute('data-total-pages') || '1');
      const currentPage = Number(grid.getAttribute('data-current-page') || '1');
      if (totalPages <= 1) {
        section.dataset.saleAllLoaded = 'true';
        return;
      }

      const myId = ++latestSaleLoadId;
      section.dataset.saleLoadInFlight = 'true';
      section.classList.add('is-loading');

      const sectionId = section.getAttribute('data-section-id');
      const collectionUrl = section.getAttribute('data-collection-url');

      // Base filter params come from whichever form triggered the
      // toggle. Falls back to the first filter form on the section if
      // called from a context without one.
      const form = sourceForm || section.querySelector('[data-catalogue-filter-form]');
      const baseParams = form ? paramsFromForm(form) : {};

      const buildPageUrl = (page) => {
        const url = new URL(collectionUrl, window.location.origin);
        Object.entries(baseParams).forEach(([key, val]) => {
          if (val == null) return;
          const isFilter = typeof key === 'string' && key.indexOf('filter.') === 0;
          if (!isFilter && val === '') return;
          if (Array.isArray(val)) val.forEach((v) => url.searchParams.append(key, v));
          else url.searchParams.set(key, val);
        });
        url.searchParams.set('page', String(page));
        url.searchParams.set('section_id', sectionId);
        return url.toString();
      };

      try {
        const pagesToLoad = [];
        for (let p = 1; p <= totalPages; p++) {
          if (p !== currentPage) pagesToLoad.push(p);
        }
        const responses = await Promise.all(
          pagesToLoad.map((p) => fetch(buildPageUrl(p), { headers: { Accept: 'text/html' } })
            .then((res) => (res.ok ? res.text() : ''))
            .then((html) => ({ page: p, html })))
        );
        if (myId !== latestSaleLoadId) return; // superseded by newer load

        const parser = new DOMParser();
        // Append in numerical page order so the appended cards keep
        // roughly the same product ordering the shopper would see when
        // paginating manually.
        responses
          .sort((a, b) => a.page - b.page)
          .forEach(({ html }) => {
            if (!html) return;
            const doc = parser.parseFromString(html, 'text/html');
            const items = doc.querySelectorAll('[data-catalogue-grid] > .catalogue__item');
            items.forEach((item) => grid.appendChild(item.cloneNode(true)));
          });

        section.dataset.saleAllLoaded = 'true';

        // Re-bind card behaviours on the freshly appended items so
        // favourites, add-to-cart, and quick-view still work.
        markSecondary(section);
        initFavourites(section);
        initAddToCart(section);
      } catch (e) {
        if (myId === latestSaleLoadId) console.warn('[catalogue] sale multi-page load failed:', e);
      } finally {
        if (myId === latestSaleLoadId) {
          section.classList.remove('is-loading');
          delete section.dataset.saleLoadInFlight;
        }
      }
    }

    /* --- Filter form: fire an AJAX update on any change instead of
           submitting to a new URL. The <form> action still points at
           collection.url so non-JS users get a normal submit fallback. --- */
    function initFilterForms(section) {
      section.querySelectorAll('[data-catalogue-filter-form]').forEach((form) => {
        // Toggle switches visual state (label ↔ hidden checkbox).
        form.querySelectorAll('[data-catalogue-toggle]').forEach((wrap) => {
          const input = wrap.querySelector('input[type=checkbox]');
          if (!input) return;
          const sync = () => wrap.classList.toggle('is-active', input.checked);
          sync();
          input.addEventListener('change', sync);
        });

        // "On sale only" toggle — pure client-side filter (no AJAX,
        // no URL change). Sale is a Shopify Collection, so filtering
        // is done by toggling `.is-sale-only` on the section, which
        // CSS uses to hide any `.catalogue__item` whose card has
        // `data-in-sale="false"`. Keeps desktop + mobile drawer
        // copies in sync via the shared section class.
        form.querySelectorAll('[data-catalogue-sale-toggle]').forEach((btn) => {
          const applyState = (on) => {
            section.classList.toggle('is-sale-only', on);
            section.querySelectorAll('[data-catalogue-sale-toggle]').forEach((otherBtn) => {
              otherBtn.classList.toggle('is-active', on);
              otherBtn.setAttribute('aria-checked', on ? 'true' : 'false');
            });
            // Load pages 2..N into the grid so the CSS "in-sale" filter
            // can see every product across the collection, not just the
            // current page. Safe to call unconditionally — the loader
            // is a no-op when totalPages <= 1 or already loaded.
            if (on) loadAllSalePages(section, form);
          };
          // Reflect the section's current state on this newly-bound
          // button (in case the sidebar was AJAX-swapped after the
          // toggle was activated in the previous cycle).
          applyState(section.classList.contains('is-sale-only'));
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            applyState(!section.classList.contains('is-sale-only'));
          });
        });

        // Price slider (single-thumb): live-repaint the fill + price pill.
        form.querySelectorAll('.catalogue-range:not(.catalogue-range--dual)').forEach((range) => {
          const input = range.querySelector('.catalogue-range__input');
          const fill = range.querySelector('.catalogue-range__fill');
          const label = form.querySelector('[data-catalogue-price-max]');
          if (!input) return;
          const paint = () => {
            const pct = (input.value - input.min) / (input.max - input.min) * 100;
            if (fill) fill.style.width = `calc((100% - 40px) * ${pct} / 100)`;
            if (label) label.textContent = '£' + Number(input.value);
          };
          paint();
          input.addEventListener('input', paint);
        });

        // Volume slider (dual-thumb): paint the between-thumbs fill, keep
        // min ≤ max, then sync hidden checkboxes and fire the AJAX filter
        // update on release.
        form.querySelectorAll('.catalogue-range--dual').forEach((range) => {
          const minInput = range.querySelector('[data-min-input]');
          const maxInput = range.querySelector('[data-max-input]');
          const fill = range.querySelector('.catalogue-range__fill');
          // Labels live in the same filter group as the range — scope the
          // lookup so multiple dual-thumb sliders (e.g. Volume + Board
          // Length) each drive their own pills.
          const group = range.closest('.catalogue-filters__group-inner') || form;
          const minLabel = group.querySelector('[data-catalogue-multi-min-label]');
          const maxLabel = group.querySelector('[data-catalogue-multi-max-label]');
          const hiddenBoxes = range.querySelectorAll('[data-catalogue-multi-value]');
          const suffix = range.getAttribute('data-suffix') || '';
          const format = range.getAttribute('data-format') || '';
          const minBound = Number(range.getAttribute('data-min'));
          const maxBound = Number(range.getAttribute('data-max'));
          if (!minInput || !maxInput || maxBound === minBound) return;

          // Length slider — format labels as `X'Y"` so shoppers see the
          // surfboard-native feet+inches rather than a raw number.
          // The metafield can store the length two different ways
          // depending on the merchant's setup:
          //   • Total inches (66 → 5'6")
          //   • Decimal feet (5.5 → 5'6")
          // Detect by magnitude — anything >= 24 is realistically inches
          // (the shortest surfboard is ~4' = 48"), so a value in decimal
          // feet would never exceed 12ish. Format either representation
          // into the same `X'Y"` pill.
          const formatValue = (v) => {
            if (format === 'length') {
              let ft, inch;
              if (v >= 24) {
                ft = Math.floor(v / 12);
                inch = Math.round(v % 12);
              } else {
                ft = Math.floor(v);
                inch = Math.round((v - ft) * 12);
              }
              // 12" would roll over — normalise.
              if (inch === 12) { ft += 1; inch = 0; }
              return ft + "'" + inch + '"';
            }
            return v + suffix;
          };

          const paint = () => {
            const minV = Number(minInput.value);
            const maxV = Number(maxInput.value);
            const span = maxBound - minBound;
            const minPct = ((minV - minBound) / span) * 100;
            const maxPct = ((maxV - minBound) / span) * 100;
            if (fill) {
              fill.style.left = `calc(20px + (100% - 40px) * ${minPct} / 100)`;
              fill.style.width = `calc((100% - 40px) * ${maxPct - minPct} / 100)`;
            }
            if (minLabel) minLabel.textContent = formatValue(minV);
            if (maxLabel) maxLabel.textContent = formatValue(maxV);
          };

          const clampMin = () => {
            if (Number(minInput.value) > Number(maxInput.value)) minInput.value = maxInput.value;
          };
          const clampMax = () => {
            if (Number(maxInput.value) < Number(minInput.value)) maxInput.value = minInput.value;
          };

          // For length filters, parse the checkbox's raw `value` string
          // (e.g. "5'6\"", "5", "66") into total inches directly in JS
          // rather than trusting the Liquid-computed
          // `data-catalogue-multi-value`. This is a resilience layer:
          // if the server-rendered attribute is stale, cached, or the
          // Liquid parsing hits an edge case, the JS still produces
          // correct comparison values so slider filtering matches the
          // slider labels exactly.
          const parseLengthToInches = (str) => {
            if (typeof str !== 'string') return NaN;
            const trimmed = str.trim();
            if (trimmed.indexOf("'") > -1) {
              const parts = trimmed.split("'");
              const ft = parseInt(parts[0], 10) || 0;
              const inStr = (parts[1] || '').replace(/["'\s]/g, '');
              const inches = parseInt(inStr, 10) || 0;
              return ft * 12 + inches;
            }
            const n = parseFloat(trimmed);
            if (isNaN(n)) return NaN;
            // Magnitude heuristic — decimal feet (<24) get converted to
            // inches; anything else is assumed to already be inches.
            return n >= 24 ? n : n * 12;
          };

          const syncCheckboxes = () => {
            const minV = Number(minInput.value);
            const maxV = Number(maxInput.value);
            const isFullRange = minV === minBound && maxV === maxBound;
            hiddenBoxes.forEach((cb) => {
              let v;
              if (format === 'length') {
                v = parseLengthToInches(cb.value);
              } else {
                v = Number(cb.getAttribute('data-catalogue-multi-value'));
              }
              cb.checked = !isFullRange && !isNaN(v) && v >= minV && v <= maxV;
            });
          };

          minInput.addEventListener('input', () => { clampMin(); paint(); });
          maxInput.addEventListener('input', () => { clampMax(); paint(); });

          const onRelease = () => {
            syncCheckboxes();
            applyFilters(section, paramsFromForm(form), form);
          };
          minInput.addEventListener('change', onRelease);
          maxInput.addEventListener('change', onRelease);

          paint();
        });

        // Fire on any input change (checkbox, single-thumb price slider,
        // toggle). Dual-thumb sliders fire their own applyFilters above,
        // so we skip the `--min` / `--max` inputs here.
        form.addEventListener('change', (event) => {
          const t = event.target;
          if (t.matches('.catalogue-range__input--min, .catalogue-range__input--max')) return;
          if (!t.matches('input[type=checkbox], input.catalogue-range__input')) return;
          applyFilters(section, paramsFromForm(form), form);
        });

        // Intercept Enter-key form submissions and the noscript fallback.
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          applyFilters(section, paramsFromForm(form), form);
        });
      });
    }

    /* Delegated click handler for sort options, pagination links, category
       menu links and Clear-filters links. Anything on the same collection
       URL is intercepted and swapped via AJAX; anything else navigates
       normally. */
    function initLinkInterception(section) {
      section.addEventListener('click', (event) => {
        // Don't hijack quick-view triggers or in-modal clicks.
        if (event.target.closest('[data-quick-view]')) return;
        if (event.target.closest('[data-quick-view-modal]')) return;
        // Card links (product page, title link, image link) should navigate.
        if (event.target.closest('.card')) return;

        const link = event.target.closest('a[href]');
        if (!link || !section.contains(link)) return;

        const href = link.getAttribute('href');
        if (!href || href.startsWith('#')) return;

        let url;
        try { url = new URL(href, window.location.href); }
        catch (e) { return; }

        const collectionUrl = section.getAttribute('data-collection-url');
        const targetPath = url.pathname;
        const currentPath = window.location.pathname;
        // Intercept links whose path is the current collection page
        // (Clear, Sort options, Pagination) OR a Shopify collection+tag
        // route beneath it (e.g. `/collections/foo/sale`, used by the
        // "On sale only" toggle). Also intercept if the target is the
        // bare collection URL and the current path is a tag view — so
        // clicking "off" the toggle from `/collections/foo/sale` back
        // to `/collections/foo` also swaps.
        // Category menu links pointing at a different collection still
        // full-navigate (the base path doesn't match).
        const isSamePage = targetPath === currentPath;
        const isBareCollection = targetPath === collectionUrl;
        const isCollectionTag =
          !!collectionUrl && targetPath.indexOf(collectionUrl + '/') === 0;
        const isTagBackToBase =
          !!collectionUrl && currentPath.indexOf(collectionUrl + '/') === 0 && targetPath === collectionUrl;
        if (!isSamePage && !isBareCollection && !isCollectionTag && !isTagBackToBase) return;

        event.preventDefault();

        const isPagination = !!link.closest('.catalogue__pagination');

        // Kick off the AJAX swap. `applyFilters` is async, so we can
        // hang a `.then()` off it to run code after the products list
        // has actually been replaced in the DOM.
        const swap = applyFilters(section, url.toString());

        // Pagination clicks — after the new products render, scroll
        // back up to the top of the products grid so the shopper isn't
        // stranded at the bottom reading the same pagination bar.
        // Runs after the swap so the freshly rendered toolbar is
        // present as the scroll target (its DOM node is replaced by
        // `swapNode` inside applyFilters). Uses Lenis's smooth-scroll
        // API when the theme has it, falling back to native scroll
        // otherwise. Offset clears the fixed header + a little
        // breathing room above.
        if (isPagination) {
          swap.then(() => {
            const scrollTarget = section.querySelector('.catalogue__toolbar')
              || section.querySelector('.catalogue__body');
            if (!scrollTarget) return;
            const HEADER_OFFSET = 120;
            if (window.oceanLenis && typeof window.oceanLenis.scrollTo === 'function') {
              window.oceanLenis.scrollTo(scrollTarget, { offset: -HEADER_OFFSET });
            } else {
              const rect = scrollTarget.getBoundingClientRect();
              window.scrollTo({
                top: Math.max(0, rect.top + window.scrollY - HEADER_OFFSET),
                behavior: 'smooth'
              });
            }
          });
        }
      });
    }

    /* --- Sort dropdown (custom-styled but the value it sets is Shopify's
           standard sort_by URL param, so re-navigation drives the data) --- */
    function initSortDropdowns(section) {
      section.querySelectorAll('[data-catalogue-sort]').forEach((sort) => {
        const toggle = sort.querySelector('[data-catalogue-sort-toggle]');
        toggle?.addEventListener('click', () => sort.classList.toggle('is-open'));
        document.addEventListener('click', (e) => {
          if (!sort.contains(e.target)) sort.classList.remove('is-open');
        });
      });
    }

    /* --- Quick view (unchanged logic from other rails) --- */
    function initQuickView(section) {
      const modal = section.querySelector('[data-quick-view-modal]');
      const hasModal = !!modal && typeof modal.showModal === 'function';

      section.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-quick-view]');
        if (!btn || !section.contains(btn) || (modal && modal.contains(btn))) return;
        event.preventDefault();
        event.stopPropagation();
        const url = btn.getAttribute('data-quick-view');
        if (!url) return;
        if (!hasModal) { window.location.href = url; return; }
        openQuickView(url);
      }, true);

      if (!hasModal) return;

      const moneyFormat = section.getAttribute('data-money-format');
      const galleryEl = modal.querySelector('[data-qv-gallery]');
      const badgeEl = modal.querySelector('[data-qv-badge]');
      const prevBtn = modal.querySelector('[data-qv-prev]');
      const nextBtn = modal.querySelector('[data-qv-next]');
      const dotsEl = modal.querySelector('[data-qv-dots]');
      const brandEl = modal.querySelector('[data-qv-brand]');
      const titleEl = modal.querySelector('[data-qv-title]');
      const priceEl = modal.querySelector('[data-qv-price]');
      const variantsWrap = modal.querySelector('[data-qv-variants]');
      const variantSelect = modal.querySelector('[data-qv-variant-select]');
      const addBtn = modal.querySelector('[data-qv-add]');
      const addLabel = modal.querySelector('[data-qv-add-label]');
      const fullLink = modal.querySelector('[data-qv-full]');

      let currentVariantId = null;
      let currentProduct = null;
      let images = [];
      let activeIndex = 0;

      function setIndex(i) {
        if (images.length === 0) return;
        activeIndex = (i + images.length) % images.length;
        galleryEl.querySelectorAll('.quick-view__image').forEach((el, idx) => el.classList.toggle('is-active', idx === activeIndex));
        if (dotsEl) dotsEl.querySelectorAll('.quick-view__dot').forEach((el, idx) => {
          el.classList.toggle('is-active', idx === activeIndex);
          el.setAttribute('aria-selected', idx === activeIndex ? 'true' : 'false');
        });
      }

      function renderGallery(imgs, title) {
        galleryEl.innerHTML = '';
        if (dotsEl) dotsEl.innerHTML = '';
        imgs.forEach((src, i) => {
          const img = document.createElement('img');
          img.src = src;
          img.alt = i === 0 ? (title || '') : '';
          img.className = 'quick-view__image' + (i === 0 ? ' is-active' : '');
          img.loading = i === 0 ? 'eager' : 'lazy';
          galleryEl.appendChild(img);
          if (dotsEl) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'quick-view__dot' + (i === 0 ? ' is-active' : '');
            dot.setAttribute('role', 'tab');
            dot.setAttribute('aria-label', `Image ${i + 1} of ${imgs.length}`);
            dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
            dot.addEventListener('click', () => setIndex(i));
            dotsEl.appendChild(dot);
          }
        });
        const hasMultiple = imgs.length > 1;
        if (prevBtn) prevBtn.hidden = !hasMultiple;
        if (nextBtn) nextBtn.hidden = !hasMultiple;
        if (dotsEl) dotsEl.hidden = !hasMultiple;
        activeIndex = 0;
      }

      function renderPrice(variant) {
        if (!variant) { priceEl.textContent = ''; return; }
        const parts = [];
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const was = document.createElement('span');
          was.className = 'quick-view__price-was';
          was.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          parts.push(was);
        }
        const now = document.createElement('span');
        now.textContent = formatMoney(variant.price, moneyFormat);
        parts.push(now);
        priceEl.innerHTML = '';
        parts.forEach((p) => priceEl.appendChild(p));
      }

      function renderBadge(product) {
        if (!badgeEl) return;
        const onSale = product.compare_at_price && product.compare_at_price > product.price;
        const isNew = product.tags && product.tags.map((t) => String(t).toLowerCase()).includes('new');
        badgeEl.className = 'quick-view__badge';
        if (onSale) { badgeEl.textContent = 'Sale'; badgeEl.classList.add('quick-view__badge--sale'); badgeEl.hidden = false; }
        else if (isNew) { badgeEl.textContent = 'New In'; badgeEl.classList.add('quick-view__badge--new'); badgeEl.hidden = false; }
        else { badgeEl.hidden = true; }
      }

      const setVariant = (variant, opts) => {
        const awaiting = opts && opts.awaitingSelection;
        currentVariantId = (!awaiting && variant) ? variant.id : null;
        renderPrice(variant);
        if (!addBtn) return;
        if (awaiting) { addBtn.disabled = true; if (addLabel) addLabel.textContent = 'Select an option'; }
        else if (!variant || !variant.available) { addBtn.disabled = true; if (addLabel) addLabel.textContent = 'Sold out'; }
        else { addBtn.disabled = false; if (addLabel) addLabel.textContent = 'Add to bag'; }
      };

      const openQuickView = async (url) => {
        try {
          const cleanUrl = String(url).split('?')[0].split('#')[0].replace(/\/$/, '');
          const res = await fetch(`${cleanUrl}.js`);
          if (!res.ok) throw new Error(`quick view fetch ${res.status}`);
          const product = await res.json();
          currentProduct = product;
          images = (product.images && product.images.length > 0) ? product.images : (product.featured_image ? [product.featured_image] : []);
          renderGallery(images, product.title);
          renderBadge(product);
          brandEl.textContent = product.vendor || '';
          brandEl.hidden = !product.vendor;
          titleEl.textContent = product.title;
          fullLink.href = url;
          variantSelect.innerHTML = '';
          if (product.variants.length > 1) {
            const placeholder = document.createElement('option');
            placeholder.value = '';
            placeholder.textContent = 'Select an option';
            placeholder.disabled = true;
            placeholder.selected = true;
            variantSelect.appendChild(placeholder);
            product.variants.forEach((v) => {
              const opt = document.createElement('option');
              opt.value = v.id;
              opt.textContent = v.available ? v.title : `${v.title} — Sold out`;
              opt.disabled = !v.available;
              variantSelect.appendChild(opt);
            });
            variantsWrap.hidden = false;
            variantSelect.value = '';
            setVariant(product.variants[0], { awaitingSelection: true });
          } else {
            variantsWrap.hidden = true;
            setVariant(product.variants[0]);
          }
          if (modal.open) modal.close();
          modal.showModal();
        } catch (e) {
          console.warn('[catalogue] quick view failed, navigating to product page:', e);
          window.location.href = url;
        }
      };

      variantSelect?.addEventListener('change', () => {
        const id = Number(variantSelect.value);
        if (!id || !currentProduct) return;
        const v = currentProduct.variants.find((x) => x.id === id);
        if (v) setVariant(v);
      });

      addBtn?.addEventListener('click', async () => {
        if (!currentVariantId) return;
        addBtn.disabled = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: currentVariantId, quantity: 1 })
          });
          if (!res.ok) throw new Error('add failed');
          await refreshCartCount();
          if (addLabel) addLabel.textContent = 'Added ✓';
          setTimeout(() => modal.close(), 900);
        } catch (e) { addBtn.disabled = false; }
      });

      prevBtn?.addEventListener('click', () => setIndex(activeIndex - 1));
      nextBtn?.addEventListener('click', () => setIndex(activeIndex + 1));
      modal.addEventListener('keydown', (event) => {
        if (images.length < 2) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); setIndex(activeIndex + 1); }
        if (event.key === 'ArrowLeft')  { event.preventDefault(); setIndex(activeIndex - 1); }
      });
      modal.querySelector('[data-quick-view-close]')?.addEventListener('click', () => modal.close());
      modal.addEventListener('click', (event) => { if (event.target === modal) modal.close(); });
    }

    function initSection(section) {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      markSecondary(section);
      initFavourites(section);
      initAddToCart(section);
      initDrawer(section);
      initFilterGroups(section);
      initFilterForms(section);
      initSortDropdowns(section);
      initLinkInterception(section);
      initQuickView(section);
    }

    const boot = () => document.querySelectorAll('[data-catalogue]').forEach(initSection);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-catalogue]').forEach(initSection);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-shapers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-shapers-scroller]').forEach((scroller) => {
      const section = scroller.closest('.custom-shapers');
      if (!section || scroller.dataset.initialized === 'true') return;
      scroller.dataset.initialized = 'true';

      const prev = section.querySelector('[data-shapers-prev]');
      const next = section.querySelector('[data-shapers-next]');

      const step = () => {
        const first = scroller.querySelector('.custom-shapers__item');
        if (!first) return 320;
        const w = first.getBoundingClientRect().width;
        return w + 16;
      };
      if (prev) prev.addEventListener('click', () => scroller.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => scroller.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fins-upsell"] && !Shopify.designMode) return;
  try {
    
  (() => {
    async function refreshCartCount() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
        });
      } catch (e) { /* ignore */ }
    }

    function initSection(section) {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      // --- Carousel arrows ---
      const scroller = section.querySelector('[data-fins-scroller]');
      const prev = section.querySelector('[data-fins-prev]');
      const next = section.querySelector('[data-fins-next]');

      const scrollByCard = (direction) => {
        const card = scroller?.querySelector('.fins-upsell__item');
        const width = card ? card.getBoundingClientRect().width : 320;
        scroller?.scrollBy({ left: direction * (width + 28), behavior: 'smooth' });
      };

      const updateArrows = () => {
        if (!scroller || !prev || !next) return;
        const maxScroll = scroller.scrollWidth - scroller.clientWidth - 1;
        prev.disabled = scroller.scrollLeft <= 0;
        next.disabled = scroller.scrollLeft >= maxScroll;
      };

      prev?.addEventListener('click', () => scrollByCard(-1));
      next?.addEventListener('click', () => scrollByCard(1));
      scroller?.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();

      // --- Add to bag (AJAX progressive enhancement) ---
      section.querySelectorAll('[data-fins-add]').forEach((form) => {
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = form.querySelector('button[type="submit"]');
          const label = form.querySelector('.fins-upsell__card-add-label');
          const original = label ? label.textContent : 'Add';
          if (button) button.disabled = true;
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                id: form.querySelector('[name="id"]').value,
                quantity: 1
              })
            });
            if (!res.ok) throw new Error('add failed');
            await refreshCartCount();
            if (label) label.textContent = 'Added ✓';
            setTimeout(() => {
              if (label) label.textContent = original;
              if (button) button.disabled = false;
            }, 1600);
          } catch (e) {
            form.submit();
          }
        });
      });
    }

    const boot = () => document.querySelectorAll('[data-fins-upsell]').forEach(initSection);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-fins-upsell]').forEach(initSection);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const SCROLL_THRESHOLD = 40; // px past which we exit the "top" state
    const HIDE_DELTA = 8;        // per-tick delta before hiding on scroll-down

    /* Shared solid-state toggle used by both the scroll handler and the
       mega open/close. `is-solid` = white nav bar + ink text/icons. */
    function applySolidState(header) {
      const forceSolid = header.getAttribute('data-force-solid') === 'true';
      const megaOpen = header.classList.contains('is-mega-open');
      const isTop = window.pageYOffset <= SCROLL_THRESHOLD;
      header.classList.toggle('is-solid', forceSolid || !isTop || megaOpen);
    }

    /* --- Scroll state manager --- */
    function initScroll(header) {
      let lastY = window.pageYOffset;
      let ticking = false;

      const apply = () => {
        const y = window.pageYOffset;
        const isTop = y <= SCROLL_THRESHOLD;
        const scrolledDown = y > lastY && y > SCROLL_THRESHOLD * 2;

        header.classList.toggle('is-scrolled', !isTop);
        applySolidState(header);
        // At the top of the page the header must always be visible —
        // clear is-hidden unconditionally so tiny post-scroll deltas can't
        // leave it stuck off-screen.
        if (isTop) {
          header.classList.remove('is-hidden');
        } else if (!header.classList.contains('is-mega-open') && Math.abs(y - lastY) > HIDE_DELTA) {
          // Otherwise only hide when moving down past the threshold and no mega open.
          header.classList.toggle('is-hidden', scrolledDown);
        }
        lastY = y;
        ticking = false;
      };

      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(apply);
          ticking = true;
        }
      }, { passive: true });

      apply();
    }

    /* --- Mega menu hover + click state --- */
    function initMega(header) {
      const megaWrap = header.querySelector('[data-site-header-mega-wrap]');
      const megas = header.querySelectorAll('[data-site-header-mega]');
      const items = header.querySelectorAll('[data-site-header-nav-item]');
      // Every nav item — used to close the open mega when the shopper
      // hovers a link that DOESN'T have a mega (Trade / Blog / Sale).
      const allNavItems = header.querySelectorAll('.site-header__nav-item');
      if (!megaWrap || megas.length === 0) return;

      let openKey = null;
      let leaveTimer = null;

      const show = (key) => {
        if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
        openKey = key;
        header.classList.add('is-mega-open');
        applySolidState(header);
        items.forEach((it) => {
          const on = it.getAttribute('data-mega-target') === key;
          it.classList.toggle('is-open', on);
          it.querySelector('.site-header__nav-link')?.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
        megas.forEach((m) => m.classList.toggle('is-open', m.getAttribute('data-site-header-mega') === key));
      };

      const hide = () => {
        openKey = null;
        header.classList.remove('is-mega-open');
        applySolidState(header);
        items.forEach((it) => {
          it.classList.remove('is-open');
          it.querySelector('.site-header__nav-link')?.setAttribute('aria-expanded', 'false');
        });
        megas.forEach((m) => m.classList.remove('is-open'));
      };

      const scheduleHide = () => {
        if (leaveTimer) clearTimeout(leaveTimer);
        leaveTimer = setTimeout(hide, 150);
      };

      items.forEach((item) => {
        const key = item.getAttribute('data-mega-target');
        item.addEventListener('mouseenter', () => show(key));
        item.addEventListener('focusin', () => show(key));
      });

      // Non-mega nav items (Trade / Blog / Sale) should close whatever
      // mega is currently open the moment the shopper hovers them,
      // otherwise the previously-hovered mega hangs on the 150ms
      // scheduleHide timer while they're already on a different link.
      allNavItems.forEach((item) => {
        if (item.hasAttribute('data-site-header-nav-item')) return;
        item.addEventListener('mouseenter', () => {
          if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
          hide();
        });
        item.addEventListener('focusin', hide);
      });

      header.querySelector('[data-site-header-nav]')?.addEventListener('mouseleave', scheduleHide);
      megaWrap.addEventListener('mouseenter', () => { if (leaveTimer) clearTimeout(leaveTimer); });
      megaWrap.addEventListener('mouseleave', scheduleHide);

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && openKey) hide();
      });
    }

    /* --- Mobile drawer --- */
    function initMobile(header) {
      const drawer = header.querySelector('[data-site-header-drawer]');
      const openBtn = header.querySelector('[data-site-header-mobile-open]');
      const closeBtns = header.querySelectorAll('[data-site-header-mobile-close]');
      if (!drawer || !openBtn) return;

      const open = () => {
        drawer.setAttribute('aria-hidden', 'false');
        openBtn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('site-header-drawer-open');
        openBtn.querySelector('.site-header__hamburger-bars')?.classList.add('is-open');
      };
      const close = () => {
        drawer.setAttribute('aria-hidden', 'true');
        openBtn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('site-header-drawer-open');
        openBtn.querySelector('.site-header__hamburger-bars')?.classList.remove('is-open');
      };

      openBtn.addEventListener('click', () => {
        drawer.getAttribute('aria-hidden') === 'false' ? close() : open();
      });
      closeBtns.forEach((b) => b.addEventListener('click', close));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
      });

      // Accordion toggles for each nav item with children.
      drawer.querySelectorAll('[data-site-header-drawer-toggle]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const item = btn.closest('.site-header__drawer-item');
          if (!item) return;
          const isOpen = item.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      });
    }

    function initHeader(header) {
      if (!header || header.dataset.initialized === 'true') return;
      header.dataset.initialized = 'true';
      initScroll(header);
      initMega(header);
      initMobile(header);

      // Track the marquee height so the CSS variable is correct even if
      // the merchant tweaks font size or padding.
      const marquee = document.querySelector('.header-marquee');
      if (marquee) {
        const setVar = () => document.documentElement.style.setProperty('--header-marquee-height', marquee.offsetHeight + 'px');
        setVar();
        window.addEventListener('resize', setVar);
      }
    }

    const boot = () => document.querySelectorAll('[data-site-header]').forEach(initHeader);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-site-header]').forEach(initHeader);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bodyBaseClass = 'has-hero-slider-under-nav';
    const bodyLightClass = 'has-hero-slider-under-nav--light';
    const bodyDarkClass = 'has-hero-slider-under-nav--dark';

    function applyHeaderOverlay(root) {
      if (root.dataset.underNavigation !== 'true') return;

      const section = root.closest('.shopify-section');
      const previousSection = section ? section.previousElementSibling : null;
      const canOverlay =
        !previousSection ||
        previousSection.className.includes('header-group') ||
        previousSection.id.includes('header');

      if (!canOverlay) return;

      document.body.classList.add(bodyBaseClass);
      document.body.classList.remove(bodyLightClass, bodyDarkClass);
      document.body.classList.add(`${bodyBaseClass}--${root.dataset.headerStyle}`);
    }

    function initHeroSlider(root) {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      const contents = Array.from(root.querySelectorAll('[data-slide-content]'));
      const dots = Array.from(root.querySelectorAll('[data-slide-trigger]'));
      const previousButton = root.querySelector('[data-slide-prev]');
      const nextButton = root.querySelector('[data-slide-next]');
      const currentSlideLabel = root.querySelector('[data-current-slide]');

      const autoplayEnabled = root.dataset.autoplay === 'true';
      const pauseOnHover = root.dataset.pauseOnHover === 'true';
      const interval = Number.parseInt(root.dataset.interval, 10) || 8500;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;
      let autoplayTimer = null;

      const updateCounter = () => {
        if (currentSlideLabel) {
          currentSlideLabel.textContent = String(activeIndex + 1).padStart(2, '0');
        }
      };

      const restartDotFill = () => {
        if (!autoplayEnabled || reduceMotion) return;
        const activeDot = dots[activeIndex];
        if (!activeDot) return;
        activeDot.classList.remove('is-animating');
        // Force reflow so the animation restarts from 0 on each slide change.
        void activeDot.offsetWidth;
        activeDot.classList.add('is-animating');
      };

      const setActiveSlide = (nextIndex) => {
        activeIndex = (nextIndex + slides.length) % slides.length;

        slides.forEach((slide, i) => {
          const isActive = i === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });

        contents.forEach((content, i) => {
          const isActive = i === activeIndex;
          content.classList.toggle('is-active', isActive);
          content.setAttribute('aria-hidden', String(!isActive));
        });

        dots.forEach((dot, i) => {
          const isActive = i === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', String(isActive));
          if (!isActive) dot.classList.remove('is-animating');
        });

        updateCounter();
        restartDotFill();
      };

      const stopAutoplay = () => {
        if (autoplayTimer) {
          window.clearTimeout(autoplayTimer);
          autoplayTimer = null;
        }
      };

      const scheduleAutoplay = () => {
        if (!autoplayEnabled || slides.length < 2 || reduceMotion) return;
        stopAutoplay();
        autoplayTimer = window.setTimeout(() => {
          setActiveSlide(activeIndex + 1);
          scheduleAutoplay();
        }, interval);
      };

      previousButton?.addEventListener('click', () => {
        setActiveSlide(activeIndex - 1);
        scheduleAutoplay();
      });

      nextButton?.addEventListener('click', () => {
        setActiveSlide(activeIndex + 1);
        scheduleAutoplay();
      });

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          setActiveSlide(i);
          scheduleAutoplay();
        });
      });

      if (pauseOnHover) {
        const pause = () => {
          stopAutoplay();
          const activeDot = dots[activeIndex];
          activeDot?.classList.remove('is-animating');
        };
        root.addEventListener('mouseenter', pause);
        root.addEventListener('mouseleave', () => {
          restartDotFill();
          scheduleAutoplay();
        });
        root.addEventListener('focusin', pause);
        root.addEventListener('focusout', () => {
          restartDotFill();
          scheduleAutoplay();
        });
      }

      // Touch swipe
      let touchStartX = null;
      root.addEventListener(
        'touchstart',
        (event) => {
          touchStartX = event.touches[0]?.clientX ?? null;
        },
        { passive: true }
      );
      root.addEventListener(
        'touchend',
        (event) => {
          if (touchStartX == null) return;
          const dx = (event.changedTouches[0]?.clientX ?? 0) - touchStartX;
          if (Math.abs(dx) > 40) {
            setActiveSlide(activeIndex + (dx < 0 ? 1 : -1));
            scheduleAutoplay();
          }
          touchStartX = null;
        },
        { passive: true }
      );

      document.addEventListener('shopify:block:select', (event) => {
        const blockId = event.target?.dataset?.blockId;
        if (!blockId) return;
        const slideIndex = slides.findIndex((slide) => slide.dataset.blockId === blockId);
        if (slideIndex > -1) {
          stopAutoplay();
          setActiveSlide(slideIndex);
        }
      });

      setActiveSlide(activeIndex);
      applyHeaderOverlay(root);
      scheduleAutoplay();
    }

    document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-hero-slider]').forEach(initHeroSlider);
    });

    /* Trust-strip mobile carousel — on < 768px the trust list turns
       into a 1-item-per-slide horizontal scroller (styled in CSS).
       Autoplay only advances forward. To loop without a visible
       "snap back" when reaching the last item, we clone the whole
       list once and append the copies: the scroller now has A B C D
       A' B' C' D'. When the smooth scroll lands on a clone, we
       silently reset scrollLeft to the equivalent position in the
       original set (no animation) so the next forward advance
       continues in the same visual direction. */
    function initTrustCarousel(list) {
      const originalItems = Array.from(list.querySelectorAll('.hero-slider__trust-item'));
      const originalCount = originalItems.length;
      if (originalCount <= 1) return;

      const mq = window.matchMedia('(max-width: 899px)');
      let intervalId = null;
      let paused = false;
      let cloned = false;
      let current = 0;

      const ensureClones = () => {
        if (cloned) return;
        originalItems.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.dataset.trustClone = 'true';
          list.appendChild(clone);
        });
        cloned = true;
      };
      const removeClones = () => {
        if (!cloned) return;
        list.querySelectorAll('[data-trust-clone]').forEach((el) => el.remove());
        cloned = false;
      };

      const advance = () => {
        const items = list.querySelectorAll('.hero-slider__trust-item');
        current++;
        if (current >= items.length) {
          // Safety — shouldn't happen with clones in place, but bail
          // to the start rather than throwing.
          current = 0;
          list.scrollTo({ left: 0, behavior: 'auto' });
          return;
        }
        list.scrollTo({ left: items[current].offsetLeft, behavior: 'smooth' });

        // Once we've scrolled into the clone half, wait for the smooth
        // animation to settle, then silently jump back to the mirror
        // position in the original half so the next tick advances
        // forward again instead of scrolling backwards to the start.
        if (current >= originalCount) {
          setTimeout(() => {
            current -= originalCount;
            list.scrollTo({ left: items[current].offsetLeft, behavior: 'auto' });
          }, 650);
        }
      };

      const start = () => {
        if (intervalId || paused) return;
        intervalId = setInterval(advance, 3500);
      };
      const stop = () => {
        if (!intervalId) return;
        clearInterval(intervalId);
        intervalId = null;
      };

      const sync = () => {
        if (mq.matches) {
          ensureClones();
          start();
        } else {
          stop();
          removeClones();
          current = 0;
          list.scrollLeft = 0;
        }
      };
      sync();
      mq.addEventListener('change', sync);

      // Pause when the shopper is actively swiping; resume 4s after
      // they let go so the carousel doesn't hijack their scroll.
      let resumeTimer = null;
      const pauseTemporarily = () => {
        paused = true;
        stop();
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(() => {
          paused = false;
          if (mq.matches) start();
        }, 4000);
      };
      list.addEventListener('touchstart', pauseTemporarily, { passive: true });
      list.addEventListener('pointerdown', pauseTemporarily);
    }
    document.querySelectorAll('[data-trust-list]').forEach(initTrustCarousel);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-trust-list]').forEach(initTrustCarousel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function formatMoney(cents, format) {
      const amount = cents / 100;
      const withDecimals = amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const noDecimals = Math.round(amount).toLocaleString();
      if (!format) return withDecimals;
      // Build the placeholder matcher dynamically so no literal Liquid braces appear in this file.
      const brace = String.fromCharCode(123);
      const re = new RegExp(brace + brace + '\\s*(amount_no_decimals|amount_with_comma_separator|amount_with_space_separator|amount)\\s*\\}\\}', 'g');
      return format.replace(re, (match, token) => (token === 'amount_no_decimals' ? noDecimals : withDecimals));
    }

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        if (count > 0) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
    }

    async function refreshCartCount() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        updateCartCount(cart.item_count);
      } catch (e) {
        /* ignore */
      }
    }

    // --- Favourites (localStorage, no app required) ---
    const FAV_KEY = 'om:favourites';
    const getFavourites = () => {
      try {
        return JSON.parse(localStorage.getItem(FAV_KEY) || '[]');
      } catch (e) {
        return [];
      }
    };
    const setFavourites = (list) => localStorage.setItem(FAV_KEY, JSON.stringify(list));

    function initFavourites(root) {
      const favs = getFavourites();
      root.querySelectorAll('[data-favourite]').forEach((btn) => {
        const id = btn.getAttribute('data-favourite');
        if (favs.includes(id)) btn.setAttribute('aria-pressed', 'true');
        btn.addEventListener('click', () => {
          const current = getFavourites();
          const pressed = btn.getAttribute('aria-pressed') === 'true';
          if (pressed) {
            btn.setAttribute('aria-pressed', 'false');
            setFavourites(current.filter((x) => x !== id));
          } else {
            btn.setAttribute('aria-pressed', 'true');
            if (!current.includes(id)) current.push(id);
            setFavourites(current);
          }
        });
      });
    }

    // --- Hover image preference: only fade primary out when a secondary exists ---
    function markSecondary(root) {
      root.querySelectorAll('[data-product-card]').forEach((card) => {
        if (card.querySelector('.card__image--secondary')) {
          card.querySelector('.card__image--primary')?.classList.add('has-secondary');
        }
      });
    }

    // --- Add to cart (AJAX with progressive enhancement) ---
    function initAddToCart(root) {
      root.querySelectorAll('[data-card-add]').forEach((form) => {
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = form.querySelector('button[type="submit"]');
          const labels = form.querySelectorAll('.card__roll-a, .card__roll-b');
          const original = labels[0] ? labels[0].textContent.trim() : 'Add to bag';
          if (button) button.disabled = true;

          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                id: form.querySelector('[name="id"]').value,
                quantity: 1
              })
            });
            if (!res.ok) throw new Error('add failed');
            await refreshCartCount();
            labels.forEach((l) => { l.textContent = 'Added ✓'; });
            setTimeout(() => {
              labels.forEach((l) => { l.textContent = original; });
              if (button) button.disabled = false;
            }, 1600);
          } catch (e) {
            // Fallback: hand off to the normal cart page submit.
            form.submit();
          }
        });
      });
    }

    // --- Quick view ---
    function initQuickView(section) {
      const modal = section.querySelector('[data-quick-view-modal]');
      const hasModal = !!modal && typeof modal.showModal === 'function';

      // Delegation is registered UNCONDITIONALLY so that even if the modal
      // isn't present (feature disabled, browser missing <dialog> support,
      // etc.) a Quick view click still takes the shopper somewhere useful
      // — the product page — instead of doing nothing. Capture phase so we
      // intercept before any earlier bubble-phase listener might redirect.
      section.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-quick-view]');
        if (!btn || !section.contains(btn) || (modal && modal.contains(btn))) return;
        event.preventDefault();
        event.stopPropagation();
        const url = btn.getAttribute('data-quick-view');
        if (!url) return;
        if (!hasModal) { window.location.href = url; return; }
        openQuickView(url);
      }, true);

      if (!hasModal) return;

      const moneyFormat = section.getAttribute('data-money-format');
      const galleryEl = modal.querySelector('[data-qv-gallery]');
      const badgeEl = modal.querySelector('[data-qv-badge]');
      const prevBtn = modal.querySelector('[data-qv-prev]');
      const nextBtn = modal.querySelector('[data-qv-next]');
      const dotsEl = modal.querySelector('[data-qv-dots]');
      const brandEl = modal.querySelector('[data-qv-brand]');
      const titleEl = modal.querySelector('[data-qv-title]');
      const priceEl = modal.querySelector('[data-qv-price]');
      const variantsWrap = modal.querySelector('[data-qv-variants]');
      const variantSelect = modal.querySelector('[data-qv-variant-select]');
      const addBtn = modal.querySelector('[data-qv-add]');
      const addLabel = modal.querySelector('[data-qv-add-label]');
      const fullLink = modal.querySelector('[data-qv-full]');

      let currentVariantId = null;
      let currentProduct = null;
      let images = [];
      let activeIndex = 0;

      function setIndex(i) {
        if (images.length === 0) return;
        activeIndex = (i + images.length) % images.length;
        galleryEl.querySelectorAll('.quick-view__image').forEach((el, idx) => {
          el.classList.toggle('is-active', idx === activeIndex);
        });
        if (dotsEl) {
          dotsEl.querySelectorAll('.quick-view__dot').forEach((el, idx) => {
            el.classList.toggle('is-active', idx === activeIndex);
            el.setAttribute('aria-selected', idx === activeIndex ? 'true' : 'false');
          });
        }
      }

      function renderGallery(imgs, title) {
        galleryEl.innerHTML = '';
        if (dotsEl) dotsEl.innerHTML = '';

        imgs.forEach((src, i) => {
          const img = document.createElement('img');
          img.src = src;
          img.alt = i === 0 ? (title || '') : '';
          img.className = 'quick-view__image' + (i === 0 ? ' is-active' : '');
          img.loading = i === 0 ? 'eager' : 'lazy';
          galleryEl.appendChild(img);

          if (dotsEl) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'quick-view__dot' + (i === 0 ? ' is-active' : '');
            dot.setAttribute('role', 'tab');
            dot.setAttribute('aria-label', `Image ${i + 1} of ${imgs.length}`);
            dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
            dot.addEventListener('click', () => setIndex(i));
            dotsEl.appendChild(dot);
          }
        });

        const hasMultiple = imgs.length > 1;
        if (prevBtn) prevBtn.hidden = !hasMultiple;
        if (nextBtn) nextBtn.hidden = !hasMultiple;
        if (dotsEl) dotsEl.hidden = !hasMultiple;
        activeIndex = 0;
      }

      function renderPrice(variant) {
        if (!variant) { priceEl.textContent = ''; return; }
        const parts = [];
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const was = document.createElement('span');
          was.className = 'quick-view__price-was';
          was.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          parts.push(was);
        }
        const now = document.createElement('span');
        now.textContent = formatMoney(variant.price, moneyFormat);
        parts.push(now);
        priceEl.innerHTML = '';
        parts.forEach((p) => priceEl.appendChild(p));
      }

      function renderBadge(product) {
        if (!badgeEl) return;
        const onSale = product.compare_at_price && product.compare_at_price > product.price;
        const isNew = product.tags && product.tags.map((t) => String(t).toLowerCase()).includes('new');
        badgeEl.className = 'quick-view__badge';
        if (onSale) {
          badgeEl.textContent = 'Sale';
          badgeEl.classList.add('quick-view__badge--sale');
          badgeEl.hidden = false;
        } else if (isNew) {
          badgeEl.textContent = 'New In';
          badgeEl.classList.add('quick-view__badge--new');
          badgeEl.hidden = false;
        } else {
          badgeEl.hidden = true;
        }
      }

      const setVariant = (variant, opts) => {
        const awaiting = opts && opts.awaitingSelection;
        currentVariantId = (!awaiting && variant) ? variant.id : null;
        renderPrice(variant);
        if (!addBtn) return;
        if (awaiting) {
          addBtn.disabled = true;
          if (addLabel) addLabel.textContent = 'Select an option';
        } else if (!variant || !variant.available) {
          addBtn.disabled = true;
          if (addLabel) addLabel.textContent = 'Sold out';
        } else {
          addBtn.disabled = false;
          if (addLabel) addLabel.textContent = 'Add to bag';
        }
      };

      const openQuickView = async (url) => {
        try {
          // Sanitise the URL: strip query, hash and trailing slash so that
          // `${url}.js` is always a valid Shopify product JSON endpoint.
          const cleanUrl = String(url).split('?')[0].split('#')[0].replace(/\/$/, '');
          const res = await fetch(`${cleanUrl}.js`);
          if (!res.ok) throw new Error(`quick view fetch ${res.status}`);
          const product = await res.json();
          currentProduct = product;

          // Build gallery — prefer product.images, fall back to featured_image.
          images = (product.images && product.images.length > 0)
            ? product.images
            : (product.featured_image ? [product.featured_image] : []);
          renderGallery(images, product.title);

          renderBadge(product);

          brandEl.textContent = product.vendor || '';
          brandEl.hidden = !product.vendor;
          titleEl.textContent = product.title;
          fullLink.href = url;

          variantSelect.innerHTML = '';
          if (product.variants.length > 1) {
            // Placeholder that MUST be replaced with a real pick. Disabled +
            // selected so the browser shows it initially but users can't
            // submit it.
            const placeholder = document.createElement('option');
            placeholder.value = '';
            placeholder.textContent = 'Select an option';
            placeholder.disabled = true;
            placeholder.selected = true;
            variantSelect.appendChild(placeholder);

            product.variants.forEach((v) => {
              const opt = document.createElement('option');
              opt.value = v.id;
              opt.textContent = v.available ? v.title : `${v.title} — Sold out`;
              opt.disabled = !v.available;
              variantSelect.appendChild(opt);
            });
            variantsWrap.hidden = false;
            variantSelect.value = '';
            // Show the first variant's price so the popup isn't blank, but
            // hold the CTA in a disabled "Select an option" state until the
            // shopper actually picks.
            setVariant(product.variants[0], { awaitingSelection: true });
          } else {
            variantsWrap.hidden = true;
            setVariant(product.variants[0]);
          }

          // Guard: showModal() throws if already open. Close first, then
          // open, so a second click on a different card resets cleanly.
          if (modal.open) modal.close();
          modal.showModal();
        } catch (e) {
          // Log so it shows up in dev tools instead of failing silently,
          // then fall back to a hard navigation to the product page.
          console.warn('[new-arrivals] quick view failed, navigating to product page:', e);
          window.location.href = url;
        }
      };

      variantSelect?.addEventListener('change', () => {
        const id = Number(variantSelect.value);
        if (!id || !currentProduct) return;
        const v = currentProduct.variants.find((x) => x.id === id);
        if (v) setVariant(v);
      });

      addBtn?.addEventListener('click', async () => {
        if (!currentVariantId) return;
        addBtn.disabled = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: currentVariantId, quantity: 1 })
          });
          if (!res.ok) throw new Error('add failed');
          await refreshCartCount();
          if (addLabel) addLabel.textContent = 'Added ✓';
          setTimeout(() => modal.close(), 900);
        } catch (e) {
          addBtn.disabled = false;
        }
      });

      prevBtn?.addEventListener('click', () => setIndex(activeIndex - 1));
      nextBtn?.addEventListener('click', () => setIndex(activeIndex + 1));

      modal.addEventListener('keydown', (event) => {
        if (images.length < 2) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); setIndex(activeIndex + 1); }
        if (event.key === 'ArrowLeft')  { event.preventDefault(); setIndex(activeIndex - 1); }
      });

      modal.querySelector('[data-quick-view-close]')?.addEventListener('click', () => modal.close());
      modal.addEventListener('click', (event) => {
        if (event.target === modal) modal.close();
      });
    }

    // --- Carousel arrows ---
    function initCarousel(section) {
      const scroller = section.querySelector('[data-na-scroller]');
      const prev = section.querySelector('[data-na-prev]');
      const next = section.querySelector('[data-na-next]');
      if (!scroller) return;

      const scrollByCard = (direction) => {
        const card = scroller.querySelector('.new-arrivals__item');
        const width = card ? card.getBoundingClientRect().width : 320;
        scroller.scrollBy({ left: direction * (width + 16), behavior: 'smooth' });
      };

      const updateArrows = () => {
        const maxScroll = scroller.scrollWidth - scroller.clientWidth - 1;
        if (prev) prev.disabled = scroller.scrollLeft <= 0;
        if (next) next.disabled = scroller.scrollLeft >= maxScroll;
      };

      prev?.addEventListener('click', () => scrollByCard(-1));
      next?.addEventListener('click', () => scrollByCard(1));
      scroller.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    function initSection(section) {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      markSecondary(section);
      initFavourites(section);
      initAddToCart(section);
      initCarousel(section);
      initQuickView(section);
    }

    const boot = () => document.querySelectorAll('[data-new-arrivals]').forEach(initSection);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-new-arrivals]').forEach(initSection);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function initNewsletter(form) {
      if (!form || form.dataset.initialized === 'true') return;
      form.dataset.initialized = 'true';

      const section = form.closest('[data-newsletter]');
      const emailInput = form.querySelector('[data-newsletter-email]');
      const submit = form.querySelector('[data-newsletter-submit]');
      const labelEl = form.querySelector('[data-newsletter-label]');
      const errorEl = form.querySelector('[data-newsletter-error]');
      const successEl = section?.querySelector('[data-newsletter-success]');

      const companyId = form.dataset.companyId;
      const listId = form.dataset.listId;
      const revision = form.dataset.revision || '2026-04-15';
      const source = form.dataset.source || 'Website';
      const defaultLabel = labelEl ? labelEl.textContent : 'Subscribe';

      const showError = (message) => {
        if (!errorEl) return;
        errorEl.textContent = message;
        errorEl.hidden = false;
      };

      const clearError = () => {
        if (!errorEl) return;
        errorEl.hidden = true;
        errorEl.textContent = '';
      };

      const setSubmitting = (isSubmitting) => {
        submit.disabled = isSubmitting;
        if (labelEl) labelEl.textContent = isSubmitting ? 'Sending' : defaultLabel;
      };

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        clearError();

        const email = (emailInput?.value || '').trim();
        if (!EMAIL_RE.test(email)) {
          showError('Please enter a valid email address.');
          emailInput?.focus();
          return;
        }

        if (!companyId || !listId) {
          showError('Newsletter is not configured yet.');
          return;
        }

        setSubmitting(true);

        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email } } },
              custom_source: source
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        };

        try {
          const response = await fetch(
            `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`,
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', revision },
              body: JSON.stringify(payload)
            }
          );

          if (response.ok) {
            if (section && successEl) {
              section.classList.add('is-success');
              successEl.hidden = false;
            }
            return;
          }

          let message = 'Something went wrong. Please try again.';
          try {
            const body = await response.json();
            if (body?.errors?.length && body.errors[0].detail) {
              message = body.errors[0].detail;
            }
          } catch (e) {
            /* non-JSON error body */
          }
          showError(message);
          setSubmitting(false);
        } catch (e) {
          showError('Network error. Please try again.');
          setSubmitting(false);
        }
      });
    }

    const boot = () => document.querySelectorAll('[data-newsletter-form]').forEach(initNewsletter);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-newsletter-form]').forEach(initNewsletter);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-accordions"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initAccordion(item) {
      const btn = item.querySelector('[data-pdp-accordion-toggle]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        item.classList.toggle('is-open', !open);
      });
    }

    function initSection(section) {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      section.querySelectorAll('[data-pdp-accordion]').forEach(initAccordion);
    }

    const boot = () => document.querySelectorAll('[data-pdp-info]').forEach(initSection);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-pdp-info]').forEach(initSection);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* Judge.me detection — if the app embed hasn't been enabled or
       the merchant hasn't installed the app at all, the widget div
       stays empty. Hide the whole section so shoppers don't see a
       blank "What surfers are saying" heading with nothing under it.

       We wait ~2.5s for Judge.me's runtime to hydrate (their script
       normally loads within a second), then check for either:
         • a `.jdgm-` prefixed child element added by the widget, or
         • the global `window.jdgm` created by their script.
       If neither has fired, the section hides itself. Once hydrated
       it stays visible for the life of the page. */
    document.querySelectorAll('[data-pdp-reviews]').forEach((section) => {
      const widget = section.querySelector('[data-pdp-reviews-widget]');
      if (!widget) return;

      const hasJudgeMe = () => {
        if (window.jdgm || document.querySelector('.jdgm-rev')) return true;
        // Judge.me marks widgets it's hydrated with a `jdgm-widget--processed` class
        // on some widget types.
        return !!widget.querySelector('.jdgm-widget--processed, .jdgm-rev, .jdgm-histogram, .jdgm-carousel-item');
      };

      const check = () => {
        if (hasJudgeMe()) {
          section.removeAttribute('data-jdgm-missing');
          return true;
        }
        return false;
      };

      if (check()) return;

      // Poll briefly — Judge.me typically hydrates within 500-1500ms.
      let attempts = 0;
      const maxAttempts = 15; // ~4.5s total
      const id = setInterval(() => {
        attempts += 1;
        if (check() || attempts >= maxAttempts) {
          clearInterval(id);
          if (!hasJudgeMe()) section.setAttribute('data-jdgm-missing', 'true');
        }
      }, 300);
    });

    /* Dynamic star fill + rating distribution histogram.

       Both enhancements read from `jdgm.data.reviewWidget[productId]`
       (inlined by our Judge.me snippet) and are gated on the widget
       being hydrated enough for us to find `.jm-average-rating-display`
       — that's the anchor we append the histogram after, and it only
       exists once Judge.me has rendered the aggregate row.

       Star fill: sets `--rev-avg-fill-pct` on the widget wrapper.
       The stylesheet's `background-clip: text` gradient on the
       aggregate cluster's ::before uses this to clip the ink fill.

       Histogram: builds a 5→1 distribution list from `data.histogram`
       and appends it to the same stack containing the average rating,
       so it sits under the rating in the sticky sidebar. Structurally
       matches the React <Reviews /> distribution bars. */
    document.querySelectorAll('[data-pdp-reviews-widget]').forEach((widget) => {
      const mount = widget.querySelector('#judgeme_product_reviews, [data-product-id]');
      const productId = mount && mount.getAttribute('data-product-id');
      if (!productId) return;

      let starFillApplied = false;
      let histogramInjected = false;

      const enhance = () => {
        const data = window.jdgm && window.jdgm.data
          && window.jdgm.data.reviewWidget
          && window.jdgm.data.reviewWidget[productId];
        if (!data) return false;

        // 1. Star fill — doesn't need the widget hydrated.
        if (!starFillApplied) {
          const rating = parseFloat(data.average_rating);
          if (!Number.isNaN(rating)) {
            const clamped = Math.max(0, Math.min(5, rating));
            widget.style.setProperty('--rev-avg-fill-pct', (clamped / 5 * 100) + '%');
            starFillApplied = true;
          }
        }

        // 2. Distribution histogram — needs `.jm-average-rating-display`,
        //    which Judge.me renders only after hydration and only when
        //    there is at least one review. No reviews → skip (nothing
        //    meaningful to distribute) and mark as done.
        if (!histogramInjected) {
          const total = data.number_of_reviews | 0;
          if (total === 0 || !Array.isArray(data.histogram)) {
            histogramInjected = true;
          } else if (!widget.querySelector('.pdp-reviews__histogram')) {
            const avgDisplay = widget.querySelector('.jm-average-rating-display');
            const stack = avgDisplay && avgDisplay.closest('.jm-stack');
            if (stack) {
              const ul = document.createElement('ul');
              ul.className = 'pdp-reviews__histogram';
              // Judge.me returns the histogram in an unspecified order;
              // sort descending so 5-star sits at the top like React.
              const rows = data.histogram.slice().sort((a, b) => b.rating - a.rating);
              for (const entry of rows) {
                const n = entry.frequency | 0;
                const pct = total > 0 ? Math.round((n / total) * 100) : 0;
                const li = document.createElement('li');
                li.className = 'pdp-reviews__histogram-row';
                li.innerHTML =
                  '<span class="pdp-reviews__histogram-star-num">' + entry.rating + '</span>' +
                  '<span class="pdp-reviews__histogram-star-icon" aria-hidden="true">★</span>' +
                  '<span class="pdp-reviews__histogram-bar">' +
                    '<span class="pdp-reviews__histogram-bar-fill" style="width: ' + pct + '%"></span>' +
                  '</span>' +
                  '<span class="pdp-reviews__histogram-count">' + n + '</span>';
                ul.appendChild(li);
              }
              stack.appendChild(ul);
              histogramInjected = true;
            }
          }
        }

        return starFillApplied && histogramInjected;
      };

      if (enhance()) return;
      // The inline `jdgm.data.reviewWidget[id] = {...}` script runs at
      // parse time, so data is available immediately — but the widget
      // needs to hydrate before we can find its stack element for the
      // histogram. Poll for ~6s to catch late hydration.
      let attempts = 0;
      const id = setInterval(() => {
        attempts += 1;
        if (enhance() || attempts >= 20) clearInterval(id);
      }, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const FAV_KEY = 'om:favourites';

    function getFavourites() {
      try { return JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); }
      catch (e) { return []; }
    }
    function setFavourites(list) {
      localStorage.setItem(FAV_KEY, JSON.stringify(list));
    }

    function formatMoney(cents, format) {
      const amount = (cents / 100);
      const withDecimals = amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const noDecimals = Math.round(amount).toLocaleString();
      if (!format) return withDecimals;
      const brace = String.fromCharCode(123);
      const re = new RegExp(brace + brace + '\\s*(amount_no_decimals|amount_with_comma_separator|amount_with_space_separator|amount)\\s*\\}\\}', 'g');
      return format.replace(re, (m, token) => (token === 'amount_no_decimals' ? noDecimals : withDecimals));
    }

    async function refreshCartCount() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
        });
      } catch (e) { /* ignore */ }
    }

    function initGallery(section) {
      const frames = section.querySelectorAll('[data-pdp-frame]');
      const thumbs = section.querySelectorAll('[data-pdp-thumb]');
      const prev = section.querySelector('[data-pdp-prev]');
      const next = section.querySelector('[data-pdp-next]');
      const total = frames.length;
      if (total === 0) return;

      let active = 0;

      function show(i) {
        active = (i + total) % total;
        frames.forEach((f, idx) => f.classList.toggle('is-active', idx === active));
        thumbs.forEach((t, idx) => {
          const on = idx === active;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      thumbs.forEach((t) => {
        t.addEventListener('click', () => show(parseInt(t.getAttribute('data-index'), 10)));
      });
      prev?.addEventListener('click', () => show(active - 1));
      next?.addEventListener('click', () => show(active + 1));

      // Video modal — populate on click, clear on close so playback
      // stops immediately (works for both native <video> and external
      // iframes without needing player-specific postMessage APIs).
      const modal = section.querySelector('[data-pdp-video-modal]');
      const modalBody = section.querySelector('[data-pdp-video-modal-content]');
      const modalClose = section.querySelector('[data-pdp-video-close]');
      if (modal && modalBody) {
        section.querySelectorAll('[data-pdp-play]').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            const type = btn.getAttribute('data-video-type');
            const poster = btn.getAttribute('data-video-poster') || '';
            if (type === 'video') {
              // Shopify-hosted native video. Sources are transcoded
              // to multiple MP4 qualities; the browser picks the
              // first playable source.
              let sources = [];
              try { sources = JSON.parse(btn.getAttribute('data-video-sources') || '[]'); } catch (_) {}
              modalBody.innerHTML =
                '<video controls autoplay playsinline preload="auto" poster="' + poster + '">' +
                sources.map((s) => '<source src="' + s.url + '" type="' + s.mime + '">').join('') +
                '</video>';
            } else if (type === 'external_video') {
              const src = btn.getAttribute('data-video-src') || '';
              modalBody.innerHTML =
                '<iframe src="' + src + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen loading="eager"></iframe>';
            }
            if (typeof modal.showModal === 'function') {
              modal.showModal();
            } else {
              // Older browsers without <dialog>: fall back to a
              // simple show/hide. Rare on Ocean Magic's audience but
              // keeps the click from silently failing.
              modal.setAttribute('open', '');
            }
          });
        });

        function closeModal() {
          if (typeof modal.close === 'function' && modal.open) modal.close();
          else modal.removeAttribute('open');
          modalBody.innerHTML = '';
        }

        modalClose?.addEventListener('click', closeModal);
        modal.addEventListener('close', () => { modalBody.innerHTML = ''; });
        // Click backdrop (dialog element itself, not its inner
        // content) to close.
        modal.addEventListener('click', (e) => {
          if (e.target === modal) closeModal();
        });
      }
    }

    function initFavourite(section) {
      const btn = section.querySelector('[data-pdp-favourite]');
      if (!btn) return;
      const id = btn.getAttribute('data-favourite');
      const favs = getFavourites();
      if (favs.includes(id)) btn.setAttribute('aria-pressed', 'true');
      btn.addEventListener('click', () => {
        const current = getFavourites();
        const pressed = btn.getAttribute('aria-pressed') === 'true';
        if (pressed) {
          btn.setAttribute('aria-pressed', 'false');
          setFavourites(current.filter((x) => x !== id));
        } else {
          btn.setAttribute('aria-pressed', 'true');
          if (!current.includes(id)) current.push(id);
          setFavourites(current);
        }
      });
    }

    function initOptions(section) {
      const chips = section.querySelectorAll('[data-pdp-option-value]');
      const select = section.querySelector('[data-pdp-variant-select]');
      const hidden = section.querySelector('[data-pdp-variant-id]');
      const priceEl = section.querySelector('[data-pdp-price]');
      const priceWasEl = section.querySelector('[data-pdp-price-was]');
      const stockEl = section.querySelector('[data-pdp-stock]');
      const addBtn = section.querySelector('[data-pdp-add]');
      const addPriceEl = section.querySelector('[data-pdp-add-price]');
      const addLabelB = section.querySelector('[data-pdp-add-label-b]');
      const klarnaAmount = section.querySelector('[data-pdp-klarna-amount]');
      const moneyFormat = section.getAttribute('data-money-format');

      // Build a map of options for each variant.
      const productHandle = section.getAttribute('data-product-handle');
      let productData = null;
      async function loadProduct() {
        if (productData) return productData;
        try {
          const res = await fetch(`/products/${productHandle}.js`);
          productData = await res.json();
        } catch (e) { productData = null; }
        return productData;
      }

      async function applySelection() {
        const data = await loadProduct();
        if (!data) return;
        const selected = [];
        section.querySelectorAll('[data-pdp-option]').forEach((opt, i) => {
          const active = opt.querySelector('.pdp__option-chip.is-selected');
          selected[i] = active ? active.getAttribute('data-option-value') : null;
        });
        const variant = data.variants.find((v) => {
          for (let i = 0; i < selected.length; i++) {
            if (selected[i] && v.options[i] !== selected[i]) return false;
          }
          return true;
        });
        if (!variant) return;

        if (hidden) hidden.value = variant.id;
        if (select) select.value = variant.id;

        if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);
        if (priceWasEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceWasEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
            priceWasEl.hidden = false;
          } else {
            priceWasEl.hidden = true;
          }
        }
        if (addPriceEl) addPriceEl.textContent = formatMoney(variant.price, moneyFormat);
        if (addLabelB) {
          const lead = addLabelB.textContent.split('·')[0].trim();
          addLabelB.textContent = lead + ' · ' + formatMoney(variant.price, moneyFormat);
        }
        if (klarnaAmount) klarnaAmount.textContent = formatMoney(Math.round(variant.price / 3), moneyFormat);
        if (stockEl) {
          stockEl.classList.toggle('pdp__stock--out', !variant.available);
          stockEl.lastChild.textContent = variant.available ? 'In stock' : 'Out of stock';
        }
        if (addBtn) {
          addBtn.disabled = !variant.available;
        }
      }

      chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          const optionWrap = chip.closest('[data-pdp-option]');
          if (!optionWrap) return;
          optionWrap.querySelectorAll('.pdp__option-chip').forEach((c) => {
            c.classList.remove('is-selected');
            c.setAttribute('aria-checked', 'false');
          });
          chip.classList.add('is-selected');
          chip.setAttribute('aria-checked', 'true');
          applySelection();
        });
      });
    }

    function initAddToCart(section) {
      const form = section.querySelector('.pdp__form');
      const addBtn = section.querySelector('[data-pdp-add]');
      if (!form) return;

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (addBtn?.disabled) return;
        const variantId = section.querySelector('[data-pdp-variant-id]')?.value;
        if (!variantId) return;
        if (addBtn) addBtn.disabled = true;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          if (!res.ok) throw new Error('add failed');
          // Refresh the header badge, then open the sidecart. React
          // matches this: cart.add() flips setIsOpen(true).
          await refreshCartCount();
          if (window.oceanCart && typeof window.oceanCart.open === 'function') {
            window.oceanCart.open();
          }
        } catch (err) {
          // Fall back to a real form POST so the customer isn't stranded
          // (e.g. flaky network, cart validation error).
          form.submit();
          return;
        } finally {
          if (addBtn) addBtn.disabled = false;
        }
      });
    }

    function initDelivery(section) {
      const box = section.querySelector('[data-pdp-delivery]');
      if (!box) return;
      const headline = box.querySelector('[data-pdp-delivery-headline]');
      const date = box.querySelector('[data-pdp-delivery-date]');

      // Bank holidays — YYYY-MM-DD dates the merchant maintains in
      // the section schema (one per line or whitespace-separated).
      // Parsed into a Set for O(1) lookup during date walking.
      const rawHolidays = section.getAttribute('data-bank-holidays') || '';
      const bankHolidays = new Set(
        rawHolidays
          .split(/[\s,]+/)
          .map(function (s) { return s.trim(); })
          .filter(function (s) { return /^\d{4}-\d{2}-\d{2}$/.test(s); })
      );

      function isoDate(d) {
        // Local-time ISO date (YYYY-MM-DD) — using UTC ISO would shift
        // the day for late-evening visitors east of UTC.
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return y + '-' + m + '-' + day;
      }
      function isBusinessDay(d) {
        const dow = d.getDay();
        if (dow < 1 || dow > 5) return false;
        return !bankHolidays.has(isoDate(d));
      }

      // Ships within 48 hours excluding weekends and bank holidays =
      // two business days from now. If today is not a business day
      // (weekend or bank holiday), roll to the next one first, then
      // count two more business days after that as the ship-by date.
      function compute() {
        const now = new Date();
        const todayIsBiz = isBusinessDay(now);
        const shipBy = new Date(now);
        if (!todayIsBiz) {
          while (!isBusinessDay(shipBy)) shipBy.setDate(shipBy.getDate() + 1);
        }
        let added = 0;
        while (added < 2) {
          shipBy.setDate(shipBy.getDate() + 1);
          if (isBusinessDay(shipBy)) added++;
        }
        return { shipBy: shipBy, orderToday: todayIsBiz };
      }

      function render() {
        const info = compute();
        if (headline) headline.textContent = info.orderToday
          ? 'Order today, ships by'
          : 'Ships by';
        if (date) date.textContent = info.shipBy.toLocaleDateString('en-GB', {
          weekday: 'long', day: 'numeric', month: 'long'
        });
        box.hidden = false;
      }

      render();
      // Re-render every 30s so if the visitor stays on the page past
      // midnight (or across a weekday boundary), the copy rolls over
      // without a reload.
      setInterval(render, 30000);
    }

    function initSection(section) {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      initGallery(section);
      initFavourite(section);
      initOptions(section);
      initAddToCart(section);
      initDelivery(section);
    }

    const boot = () => document.querySelectorAll('[data-pdp]').forEach(initSection);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-pdp]').forEach(initSection);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function formatMoney(cents, format) {
      const amount = cents / 100;
      const withDecimals = amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const noDecimals = Math.round(amount).toLocaleString();
      if (!format) return withDecimals;
      const brace = String.fromCharCode(123);
      const re = new RegExp(brace + brace + '\\s*(amount_no_decimals|amount_with_comma_separator|amount_with_space_separator|amount)\\s*\\}\\}', 'g');
      return format.replace(re, (match, token) => (token === 'amount_no_decimals' ? noDecimals : withDecimals));
    }

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        if (count > 0) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
    }

    async function refreshCartCount() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        updateCartCount(cart.item_count);
      } catch (e) {
        /* ignore */
      }
    }

    // --- Favourites (localStorage, no app required) ---
    const FAV_KEY = 'om:favourites';
    const getFavourites = () => {
      try {
        return JSON.parse(localStorage.getItem(FAV_KEY) || '[]');
      } catch (e) {
        return [];
      }
    };
    const setFavourites = (list) => localStorage.setItem(FAV_KEY, JSON.stringify(list));

    function initFavourites(root) {
      const favs = getFavourites();
      root.querySelectorAll('[data-favourite]').forEach((btn) => {
        const id = btn.getAttribute('data-favourite');
        if (favs.includes(id)) btn.setAttribute('aria-pressed', 'true');
        btn.addEventListener('click', () => {
          const current = getFavourites();
          const pressed = btn.getAttribute('aria-pressed') === 'true';
          if (pressed) {
            btn.setAttribute('aria-pressed', 'false');
            setFavourites(current.filter((x) => x !== id));
          } else {
            btn.setAttribute('aria-pressed', 'true');
            if (!current.includes(id)) current.push(id);
            setFavourites(current);
          }
        });
      });
    }

    // --- Hover image preference: only fade primary out when a secondary exists ---
    function markSecondary(root) {
      root.querySelectorAll('[data-product-card]').forEach((card) => {
        if (card.querySelector('.card__image--secondary')) {
          card.querySelector('.card__image--primary')?.classList.add('has-secondary');
        }
      });
    }

    // --- Add to cart (AJAX with progressive enhancement) ---
    function initAddToCart(root) {
      root.querySelectorAll('[data-card-add]').forEach((form) => {
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = form.querySelector('button[type="submit"]');
          const labels = form.querySelectorAll('.card__roll-a, .card__roll-b');
          const original = labels[0] ? labels[0].textContent.trim() : 'Add to bag';
          if (button) button.disabled = true;

          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                id: form.querySelector('[name="id"]').value,
                quantity: 1
              })
            });
            if (!res.ok) throw new Error('add failed');
            await refreshCartCount();
            labels.forEach((l) => { l.textContent = 'Added ✓'; });
            setTimeout(() => {
              labels.forEach((l) => { l.textContent = original; });
              if (button) button.disabled = false;
            }, 1600);
          } catch (e) {
            form.submit();
          }
        });
      });
    }

    // --- Quick view ---
    function initQuickView(section) {
      const modal = section.querySelector('[data-quick-view-modal]');
      const hasModal = !!modal && typeof modal.showModal === 'function';

      // Delegation is registered UNCONDITIONALLY so that even if the modal
      // isn't present (feature disabled, browser missing <dialog> support,
      // etc.) a Quick view click still takes the shopper somewhere useful
      // — the product page — instead of doing nothing. capture phase so we
      // intercept before any earlier bubble-phase listener might redirect.
      section.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-quick-view]');
        if (!btn || !section.contains(btn) || (modal && modal.contains(btn))) return;
        event.preventDefault();
        event.stopPropagation();
        const url = btn.getAttribute('data-quick-view');
        if (!url) return;
        if (!hasModal) { window.location.href = url; return; }
        openQuickView(url);
      }, true);

      if (!hasModal) return;

      const moneyFormat = section.getAttribute('data-money-format');
      const galleryEl = modal.querySelector('[data-qv-gallery]');
      const badgeEl = modal.querySelector('[data-qv-badge]');
      const prevBtn = modal.querySelector('[data-qv-prev]');
      const nextBtn = modal.querySelector('[data-qv-next]');
      const dotsEl = modal.querySelector('[data-qv-dots]');
      const brandEl = modal.querySelector('[data-qv-brand]');
      const titleEl = modal.querySelector('[data-qv-title]');
      const priceEl = modal.querySelector('[data-qv-price]');
      const variantsWrap = modal.querySelector('[data-qv-variants]');
      const variantSelect = modal.querySelector('[data-qv-variant-select]');
      const addBtn = modal.querySelector('[data-qv-add]');
      const addLabel = modal.querySelector('[data-qv-add-label]');
      const fullLink = modal.querySelector('[data-qv-full]');

      let currentVariantId = null;
      let currentProduct = null;
      let images = [];
      let activeIndex = 0;

      function setIndex(i) {
        if (images.length === 0) return;
        activeIndex = (i + images.length) % images.length;
        galleryEl.querySelectorAll('.quick-view__image').forEach((el, idx) => {
          el.classList.toggle('is-active', idx === activeIndex);
        });
        if (dotsEl) {
          dotsEl.querySelectorAll('.quick-view__dot').forEach((el, idx) => {
            el.classList.toggle('is-active', idx === activeIndex);
            el.setAttribute('aria-selected', idx === activeIndex ? 'true' : 'false');
          });
        }
      }

      function renderGallery(imgs, title) {
        galleryEl.innerHTML = '';
        if (dotsEl) dotsEl.innerHTML = '';

        imgs.forEach((src, i) => {
          const img = document.createElement('img');
          img.src = src;
          img.alt = i === 0 ? (title || '') : '';
          img.className = 'quick-view__image' + (i === 0 ? ' is-active' : '');
          img.loading = i === 0 ? 'eager' : 'lazy';
          galleryEl.appendChild(img);

          if (dotsEl) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'quick-view__dot' + (i === 0 ? ' is-active' : '');
            dot.setAttribute('role', 'tab');
            dot.setAttribute('aria-label', `Image ${i + 1} of ${imgs.length}`);
            dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
            dot.addEventListener('click', () => setIndex(i));
            dotsEl.appendChild(dot);
          }
        });

        const hasMultiple = imgs.length > 1;
        if (prevBtn) prevBtn.hidden = !hasMultiple;
        if (nextBtn) nextBtn.hidden = !hasMultiple;
        if (dotsEl) dotsEl.hidden = !hasMultiple;
        activeIndex = 0;
      }

      function renderPrice(variant) {
        if (!variant) { priceEl.textContent = ''; return; }
        const parts = [];
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const was = document.createElement('span');
          was.className = 'quick-view__price-was';
          was.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          parts.push(was);
        }
        const now = document.createElement('span');
        now.textContent = formatMoney(variant.price, moneyFormat);
        parts.push(now);
        priceEl.innerHTML = '';
        parts.forEach((p) => priceEl.appendChild(p));
      }

      function renderBadge(product) {
        if (!badgeEl) return;
        const onSale = product.compare_at_price && product.compare_at_price > product.price;
        const isNew = product.tags && product.tags.map((t) => String(t).toLowerCase()).includes('new');
        badgeEl.className = 'quick-view__badge';
        if (onSale) {
          badgeEl.textContent = 'Sale';
          badgeEl.classList.add('quick-view__badge--sale');
          badgeEl.hidden = false;
        } else if (isNew) {
          badgeEl.textContent = 'New In';
          badgeEl.classList.add('quick-view__badge--new');
          badgeEl.hidden = false;
        } else {
          badgeEl.hidden = true;
        }
      }

      const setVariant = (variant, opts) => {
        const awaiting = opts && opts.awaitingSelection;
        currentVariantId = (!awaiting && variant) ? variant.id : null;
        renderPrice(variant);
        if (!addBtn) return;
        if (awaiting) {
          addBtn.disabled = true;
          if (addLabel) addLabel.textContent = 'Select an option';
        } else if (!variant || !variant.available) {
          addBtn.disabled = true;
          if (addLabel) addLabel.textContent = 'Sold out';
        } else {
          addBtn.disabled = false;
          if (addLabel) addLabel.textContent = 'Add to bag';
        }
      };

      const openQuickView = async (url) => {
        try {
          // Sanitise the URL: strip query, hash and trailing slash so that
          // `${url}.js` is always a valid Shopify product JSON endpoint.
          const cleanUrl = String(url).split('?')[0].split('#')[0].replace(/\/$/, '');
          const res = await fetch(`${cleanUrl}.js`);
          if (!res.ok) throw new Error(`quick view fetch ${res.status}`);
          const product = await res.json();
          currentProduct = product;

          images = (product.images && product.images.length > 0)
            ? product.images
            : (product.featured_image ? [product.featured_image] : []);
          renderGallery(images, product.title);

          renderBadge(product);

          brandEl.textContent = product.vendor || '';
          brandEl.hidden = !product.vendor;
          titleEl.textContent = product.title;
          fullLink.href = url;

          variantSelect.innerHTML = '';
          if (product.variants.length > 1) {
            // Placeholder that MUST be replaced with a real pick. Disabled +
            // selected so the browser shows it initially but users can't
            // submit it.
            const placeholder = document.createElement('option');
            placeholder.value = '';
            placeholder.textContent = 'Select an option';
            placeholder.disabled = true;
            placeholder.selected = true;
            variantSelect.appendChild(placeholder);

            product.variants.forEach((v) => {
              const opt = document.createElement('option');
              opt.value = v.id;
              opt.textContent = v.available ? v.title : `${v.title} — Sold out`;
              opt.disabled = !v.available;
              variantSelect.appendChild(opt);
            });
            variantsWrap.hidden = false;
            variantSelect.value = '';
            // Show the first variant's price so the popup isn't blank, but
            // hold the CTA in a disabled "Select an option" state until the
            // shopper actually picks.
            setVariant(product.variants[0], { awaitingSelection: true });
          } else {
            variantsWrap.hidden = true;
            setVariant(product.variants[0]);
          }

          // Guard: showModal() throws if already open. Close first, then
          // open, so a second click on a different card resets cleanly.
          if (modal.open) modal.close();
          modal.showModal();
        } catch (e) {
          // Log so it shows up in dev tools instead of failing silently,
          // then fall back to a hard navigation to the product page.
          console.warn('[related-products] quick view failed, navigating to product page:', e);
          window.location.href = url;
        }
      };

      variantSelect?.addEventListener('change', () => {
        const id = Number(variantSelect.value);
        if (!id || !currentProduct) return;
        const v = currentProduct.variants.find((x) => x.id === id);
        if (v) setVariant(v);
      });

      addBtn?.addEventListener('click', async () => {
        if (!currentVariantId) return;
        addBtn.disabled = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: currentVariantId, quantity: 1 })
          });
          if (!res.ok) throw new Error('add failed');
          await refreshCartCount();
          if (addLabel) addLabel.textContent = 'Added ✓';
          setTimeout(() => modal.close(), 900);
        } catch (e) {
          addBtn.disabled = false;
        }
      });

      prevBtn?.addEventListener('click', () => setIndex(activeIndex - 1));
      nextBtn?.addEventListener('click', () => setIndex(activeIndex + 1));

      modal.addEventListener('keydown', (event) => {
        if (images.length < 2) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); setIndex(activeIndex + 1); }
        if (event.key === 'ArrowLeft')  { event.preventDefault(); setIndex(activeIndex - 1); }
      });

      modal.querySelector('[data-quick-view-close]')?.addEventListener('click', () => modal.close());
      modal.addEventListener('click', (event) => {
        if (event.target === modal) modal.close();
      });
    }

    // --- Carousel arrows ---
    function initCarousel(section) {
      const scroller = section.querySelector('[data-rp-scroller]');
      const prev = section.querySelector('[data-rp-prev]');
      const next = section.querySelector('[data-rp-next]');
      if (!scroller) return;

      const scrollByCard = (direction) => {
        const card = scroller.querySelector('.related-products__item');
        const width = card ? card.getBoundingClientRect().width : 320;
        scroller.scrollBy({ left: direction * (width + 16), behavior: 'smooth' });
      };

      const updateArrows = () => {
        const maxScroll = scroller.scrollWidth - scroller.clientWidth - 1;
        if (prev) prev.disabled = scroller.scrollLeft <= 0;
        if (next) next.disabled = scroller.scrollLeft >= maxScroll;
      };

      prev?.addEventListener('click', () => scrollByCard(-1));
      next?.addEventListener('click', () => scrollByCard(1));
      scroller.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    // --- Swap server-rendered fallback for Shopify's personalised picks ---
    function initRecommendations(section) {
      const track = section.querySelector('[data-rp-track]');
      const productId = section.getAttribute('data-product-id');
      const sectionId = section.getAttribute('data-section-id');
      const limit = section.getAttribute('data-limit') || '12';
      if (!productId || !sectionId || !track) return;

      const url = `/recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=${limit}`;
      fetch(url)
        .then((res) => (res.ok ? res.text() : null))
        .then((html) => {
          if (!html) return;
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newTrack = doc.querySelector('[data-rp-track]');
          if (newTrack && newTrack.children.length > 0) {
            track.innerHTML = newTrack.innerHTML;
            // Re-bind card-level behaviour to the swapped-in markup.
            markSecondary(section);
            initFavourites(section);
            initAddToCart(section);
            // Reset arrow state once the new content lays out.
            requestAnimationFrame(() => {
              const evt = new Event('scroll');
              section.querySelector('[data-rp-scroller]')?.dispatchEvent(evt);
            });
          }
        })
        .catch(() => { /* silent fallback */ });
    }

    function initSection(section) {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      markSecondary(section);
      initFavourites(section);
      initAddToCart(section);
      initCarousel(section);
      initQuickView(section);
      initRecommendations(section);
    }

    const boot = () => document.querySelectorAll('[data-related-products]').forEach(initSection);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-related-products]').forEach(initSection);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-popup"]) return;
  try {
    
  (() => {
    const popup = document.querySelector('[data-search-popup]');
    if (!popup) return;

    const input = popup.querySelector('[data-search-input]');
    const results = popup.querySelector('[data-search-results]');
    const form = popup.querySelector('[data-search-form]');

    const IDLE_HTML = results.innerHTML;
    const MIN_QUERY = 2;
    const LIMIT = 6;

    let lastFocused = null;
    let debounceId = null;
    let inflightId = 0;
    let selectionIndex = -1;

    function open() {
      lastFocused = document.activeElement;
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('search-popup-open');
      requestAnimationFrame(() => input && input.focus());
    }
    function close() {
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('search-popup-open');
      if (lastFocused && typeof lastFocused.focus === 'function') {
        try { lastFocused.focus(); } catch (_) {}
      }
      resetToIdle();
    }

    function resetToIdle() {
      input.value = '';
      results.innerHTML = IDLE_HTML;
      results.setAttribute('aria-busy', 'false');
      selectionIndex = -1;
    }

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function formatMoney(cents, currency) {
      if (cents == null || isNaN(cents)) return '';
      const symbol = currency === 'GBP' ? '£' : (currency === 'USD' ? '$' : (currency === 'EUR' ? '€' : ''));
      return symbol + (cents / 100).toFixed(2);
    }

    function productRow(p) {
      const brand = p.vendor ? `<p class="search-popup__brand">${escapeHtml(p.vendor)}</p>` : '';
      const img = p.featured_image && p.featured_image.url
        ? `<div class="search-popup__thumb"><img src="${escapeHtml(p.featured_image.url)}" alt="${escapeHtml(p.title)}" loading="lazy"></div>`
        : '<div class="search-popup__thumb"></div>';
      const currency = (p.price_min_currency || 'GBP');
      let price = '';
      if (typeof p.price === 'string') {
        // Shopify's Predictive Search returns `price` as a decimal
        // string (e.g. "499.00") with no currency symbol. If the
        // merchant's API response ever includes a symbol we keep it
        // as-is; otherwise parse and run through formatMoney so the
        // shop's currency symbol prepends.
        const raw = p.price.trim();
        if (/^[£$€¥]/.test(raw)) {
          price = escapeHtml(raw);
        } else {
          const num = parseFloat(raw);
          price = isNaN(num) ? escapeHtml(raw) : formatMoney(num * 100, currency);
        }
      } else if (p.price_min != null) {
        const min = Number(p.price_min);
        const cmp = Number(p.compare_at_price_min);
        if (cmp && cmp > min) {
          price = `<span class="search-popup__price-was">${formatMoney(cmp, currency)}</span>${formatMoney(min, currency)}`;
        } else {
          price = formatMoney(min, currency);
        }
      }
      return `
        <li>
          <a class="search-popup__link" href="${escapeHtml(p.url)}" data-search-item role="option">
            ${img}
            <div class="search-popup__meta">
              ${brand}
              <p class="search-popup__title">${escapeHtml(p.title)}</p>
            </div>
            ${price ? `<span class="search-popup__price">${price}</span>` : ''}
          </a>
        </li>
      `;
    }

    function collectionRow(c) {
      const img = c.featured_image && c.featured_image.url
        ? `<div class="search-popup__thumb"><img src="${escapeHtml(c.featured_image.url)}" alt="${escapeHtml(c.title)}" loading="lazy"></div>`
        : '<div class="search-popup__thumb"></div>';
      return `
        <li>
          <a class="search-popup__link" href="${escapeHtml(c.url)}" data-search-item role="option">
            ${img}
            <div class="search-popup__meta">
              <p class="search-popup__brand">Collection</p>
              <p class="search-popup__title">${escapeHtml(c.title)}</p>
            </div>
          </a>
        </li>
      `;
    }

    function simpleRow(item, label) {
      return `
        <li>
          <a class="search-popup__link" href="${escapeHtml(item.url)}" data-search-item role="option">
            <div class="search-popup__thumb"></div>
            <div class="search-popup__meta">
              <p class="search-popup__brand">${escapeHtml(label)}</p>
              <p class="search-popup__title">${escapeHtml(item.title)}</p>
            </div>
          </a>
        </li>
      `;
    }

    // Collections that should never appear as autocomplete suggestions,
    // matched by handle. Kept in sync with the meta-tags snippet's
    // `hidden_collection_handles` list so an internal / merchandising
    // bucket is uniformly hidden from Google AND on-site search.
    const HIDDEN_COLLECTION_HANDLES = ['over-7ft-products'];

    function renderResults(payload, query) {
      const resources = (payload && payload.resources && payload.resources.results) || {};
      const products = resources.products || [];
      const collectionsRaw = resources.collections || [];
      const collections = collectionsRaw.filter(
        (c) => !HIDDEN_COLLECTION_HANDLES.includes(c.handle)
      );
      const pages = resources.pages || [];
      const articles = resources.articles || [];

      const total = products.length + collections.length + pages.length + articles.length;
      if (total === 0) {
        results.innerHTML = `
          <div class="search-popup__empty">
            <p>No matches for "${escapeHtml(query)}".</p>
          </div>
        `;
        return;
      }

      const parts = [];
      if (collections.length) {
        parts.push(`
          <section class="search-popup__section">
            <p class="search-popup__section-title">Categories</p>
            <ul class="search-popup__list" role="listbox">${collections.map(collectionRow).join('')}</ul>
          </section>
        `);
      }
      if (products.length) {
        parts.push(`
          <section class="search-popup__section">
            <p class="search-popup__section-title">Products</p>
            <ul class="search-popup__list" role="listbox">${products.map(productRow).join('')}</ul>
          </section>
        `);
      }
      if (articles.length) {
        parts.push(`
          <section class="search-popup__section">
            <p class="search-popup__section-title">Journal</p>
            <ul class="search-popup__list" role="listbox">${articles.map((a) => simpleRow(a, 'Article')).join('')}</ul>
          </section>
        `);
      }
      if (pages.length) {
        parts.push(`
          <section class="search-popup__section">
            <p class="search-popup__section-title">Pages</p>
            <ul class="search-popup__list" role="listbox">${pages.map((p) => simpleRow(p, 'Page')).join('')}</ul>
          </section>
        `);
      }

      // "View all" link submits the current query as a full search.
      const url = '/search?q=' + encodeURIComponent(query);
      parts.push(`<a class="search-popup__view-all" href="${escapeHtml(url)}">Show all results for "${escapeHtml(query)}"</a>`);

      results.innerHTML = parts.join('');
      selectionIndex = -1;
    }

    async function runSearch(query) {
      const my = ++inflightId;
      results.setAttribute('aria-busy', 'true');
      results.innerHTML = `<div class="search-popup__loading"><p>Searching…</p></div>`;
      try {
        const url = '/search/suggest.json?q=' + encodeURIComponent(query)
          + '&resources[type]=product,collection,page,article'
          + '&resources[options][unavailable_products]=last'
          + '&resources[options][fields]=title,vendor,tag,product_type'
          + '&resources[limit]=' + LIMIT;
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        const data = await res.json();
        if (my !== inflightId) return;
        renderResults(data, query);
      } catch (err) {
        if (my !== inflightId) return;
        console.error('Search suggest failed', err);
        results.innerHTML = `<div class="search-popup__empty"><p>Search unavailable — try again.</p></div>`;
      } finally {
        results.setAttribute('aria-busy', 'false');
      }
    }

    function onInput() {
      const q = input.value.trim();
      if (debounceId) clearTimeout(debounceId);
      if (q.length < MIN_QUERY) {
        results.innerHTML = IDLE_HTML;
        results.setAttribute('aria-busy', 'false');
        selectionIndex = -1;
        return;
      }
      debounceId = setTimeout(() => runSearch(q), 180);
    }

    /* Keyboard nav — Up/Down through result rows, Enter follows the
       selected link (falls back to submitting the form for a full
       search page). Esc closes. */
    function moveSelection(delta) {
      const items = Array.from(results.querySelectorAll('[data-search-item]'));
      if (!items.length) return;
      selectionIndex = (selectionIndex + delta + items.length) % items.length;
      items.forEach((el, i) => {
        if (i === selectionIndex) {
          el.setAttribute('aria-selected', 'true');
          el.scrollIntoView({ block: 'nearest' });
        } else {
          el.removeAttribute('aria-selected');
        }
      });
    }

    input.addEventListener('input', onInput);
    input.addEventListener('keydown', (evt) => {
      if (evt.key === 'ArrowDown') { evt.preventDefault(); moveSelection(1); return; }
      if (evt.key === 'ArrowUp') { evt.preventDefault(); moveSelection(-1); return; }
      if (evt.key === 'Enter') {
        const items = Array.from(results.querySelectorAll('[data-search-item]'));
        if (selectionIndex >= 0 && items[selectionIndex]) {
          evt.preventDefault();
          items[selectionIndex].click();
        }
        // else: let the form submit naturally → /search?q=...
      }
    });

    form.addEventListener('submit', () => {
      // Native submit is fine — Shopify handles /search?q=<query>.
      // Close the popup so the user sees the results page cleanly.
      setTimeout(close, 0);
    });

    popup.addEventListener('click', (evt) => {
      if (evt.target.closest('[data-search-close]')) {
        evt.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', (evt) => {
      if (evt.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
        close();
      }
    });

    document.addEventListener('click', (evt) => {
      const opener = evt.target.closest('[data-search-open]');
      if (opener) {
        evt.preventDefault();
        open();
      }
    });

    window.oceanSearch = { open, close };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["surf-film"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initSurfFilm(section) {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      // Loop a slice of the background video, if configured.
      const video = section.querySelector('[data-surf-film-video]');
      const loopStart = parseFloat(section.dataset.loopStart) || 0;
      const loopEnd = parseFloat(section.dataset.loopEnd) || 0;
      if (video && loopEnd > loopStart) {
        video.addEventListener('loadedmetadata', () => {
          try { video.currentTime = loopStart; } catch (e) { /* ignore */ }
        });
        video.addEventListener('timeupdate', () => {
          if (video.currentTime >= loopEnd) {
            try { video.currentTime = loopStart; } catch (e) { /* ignore */ }
          }
        });
      }

      // Lightbox
      const dialog = section.querySelector('[data-surf-film-dialog]');
      const embed = section.querySelector('[data-surf-film-embed]');
      const youtubeId = section.dataset.youtubeId;
      if (!dialog || !embed || !youtubeId || typeof dialog.showModal !== 'function') return;

      const open = () => {
        embed.innerHTML =
          '<iframe src="https://www.youtube.com/embed/' +
          encodeURIComponent(youtubeId) +
          '?autoplay=1&rel=0&modestbranding=1&playsinline=1" title="Film" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
        dialog.showModal();
      };
      const close = () => {
        dialog.close();
        embed.innerHTML = '';
      };

      section.querySelectorAll('[data-surf-film-open]').forEach((btn) => btn.addEventListener('click', open));
      section.querySelector('[data-surf-film-close]')?.addEventListener('click', close);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });
      dialog.addEventListener('close', () => { embed.innerHTML = ''; });
    }

    const boot = () => document.querySelectorAll('[data-surf-film]').forEach(initSurfFilm);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-surf-film]').forEach(initSurfFilm);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["surfboard-categories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initSurfCats(section) {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const scroller = section.querySelector('[data-sc-scroller]');
      const prev = section.querySelector('[data-sc-prev]');
      const next = section.querySelector('[data-sc-next]');
      if (!scroller) return;

      // Touch swipes snap automatically via `scroll-snap-type: x mandatory`
      // on `.surf-cats__track` — the browser lands on the nearest snap
      // point on release. Arrow clicks below compute the exact target
      // card's snap position and `scrollTo` it, so they land on the
      // same anchor the browser would pick after a swipe (avoids
      // overshoot from `scrollBy` + gap arithmetic mismatch).
      const currentIndex = () => {
        const items = scroller.querySelectorAll('.surf-cats__item');
        if (!items.length) return { items, index: 0 };
        // Compare each item's centre to the scroller's viewport centre
        // and pick the closest — matches the visual "which card is on
        // screen right now" regardless of snap-align mode.
        const viewportCentre = scroller.scrollLeft + scroller.clientWidth / 2;
        let bestIdx = 0;
        let bestDist = Infinity;
        items.forEach((el, i) => {
          const centre = el.offsetLeft + el.offsetWidth / 2;
          const dist = Math.abs(centre - viewportCentre);
          if (dist < bestDist) { bestDist = dist; bestIdx = i; }
        });
        return { items, index: bestIdx };
      };

      const scrollToCard = (idx) => {
        const items = scroller.querySelectorAll('.surf-cats__item');
        const target = items[idx];
        if (!target) return;
        // Detect the item's current snap alignment (differs between
        // desktop `start` and mobile `center`) and compute the exact
        // scrollLeft that puts the item at that snap point.
        const align = getComputedStyle(target).scrollSnapAlign || 'start';
        let scrollLeft;
        if (align.indexOf('center') !== -1) {
          scrollLeft = target.offsetLeft + target.offsetWidth / 2 - scroller.clientWidth / 2;
        } else {
          scrollLeft = target.offsetLeft;
        }
        scroller.scrollTo({
          left: Math.max(0, Math.round(scrollLeft)),
          behavior: 'smooth'
        });
      };

      const scrollByCard = (direction) => {
        const { items, index } = currentIndex();
        if (!items.length) return;
        const targetIdx = Math.max(0, Math.min(items.length - 1, index + direction));
        scrollToCard(targetIdx);
      };

      const updateArrows = () => {
        const maxScroll = scroller.scrollWidth - scroller.clientWidth - 1;
        if (prev) prev.disabled = scroller.scrollLeft <= 0;
        if (next) next.disabled = scroller.scrollLeft >= maxScroll;
      };

      prev?.addEventListener('click', () => scrollByCard(-1));
      next?.addEventListener('click', () => scrollByCard(1));
      scroller.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    const boot = () => document.querySelectorAll('[data-surf-cats]').forEach(initSurfCats);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-surf-cats]').forEach(initSurfCats);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
